/**
 * Özel Ölçü — AR Deneyimi v1.0
 * Sadece Paradiso Plus kalitesinde aktif.
 *  - Mevcut "giydirme" çıktısını (canvas) yüksek çözünürlükte texture yapar
 *  - Three.js ile 1:1 ölçekli ince halı mesh'i (THREE.ExtrudeGeometry) oluşturur
 *  - GLB + USDZ üretir (browser-side, USDZExporter)
 *  - Replit Object Storage'a content-hash ile cache'ler
 *  - <model-viewer> ile iOS Quick Look + Android Scene Viewer açar
 *  - Masaüstünde 3D önizleme + QR kodla telefonda açma
 *
 * Bağımlılık (CDN, lazy):
 *  - three @ esm.sh
 *  - three/examples/jsm/exporters/GLTFExporter.js
 *  - three/examples/jsm/exporters/USDZExporter.js
 *  - @google/model-viewer
 *  - qrcode (QR PNG)
 */
(function () {
  'use strict';

  // ar55.10: Boot guard — script iki kez parse/çalışırsa (V3 bloğu + V5 inject)
  // ikinci instance hiçbir şey yapmadan çıkar. Three.js "Multiple instances" uyarısı
  // ve çift handler binding bu şekilde engellenir.
  if (window.__DVB_AR_BOOTED__) { return; }
  window.__DVB_AR_BOOTED__ = true;

  // ar55.14: Self-discovery — script kendi CDN URL'sini window.__dvbArUrl'ye yazar.
  // defer scriptlerde document.currentScript null olur — DOM querySelectorAll fallback.
  // dvb-ar-product.js ve diğer modüller güncel AR URL'sini window.__dvbArUrl'den okur;
  // bu sayede hardcode fingerprint olmadan her zaman yeni versiyona referans verilir.
  (function() {
    if (window.__dvbArUrl) return; // başka bir ozel-olcu-ar.js instance zaten set etti
    // currentScript — inline/sync scriptlerde çalışır (defer'de null)
    var me = document.currentScript;
    if (me && me.src && me.src.indexOf('ozel-olcu-ar') !== -1) {
      window.__dvbArUrl = me.src;
      console.log('[DVB-AR] __dvbArUrl set via currentScript:', me.src.split('?')[1]);
      return;
    }
    // defer fallback: DOM'da script[src*="ozel-olcu-ar"] ara
    try {
      var scripts = document.querySelectorAll('script[src]');
      for (var _i = 0; _i < scripts.length; _i++) {
        if (scripts[_i].src && scripts[_i].src.indexOf('ozel-olcu-ar') !== -1) {
          window.__dvbArUrl = scripts[_i].src;
          console.log('[DVB-AR] __dvbArUrl set via querySelectorAll:', scripts[_i].src.split('?')[1]);
          return;
        }
      }
    } catch (_) {}
    // Son fallback: DOMContentLoaded sonrası tekrar dene (script defer ile yüklenmiş olabilir)
    document.addEventListener('DOMContentLoaded', function() {
      if (window.__dvbArUrl) return;
      var scrs = document.querySelectorAll('script[src]');
      for (var _j = 0; _j < scrs.length; _j++) {
        if (scrs[_j].src && scrs[_j].src.indexOf('ozel-olcu-ar') !== -1) {
          window.__dvbArUrl = scrs[_j].src;
          console.log('[DVB-AR] __dvbArUrl set via DOMContentLoaded fallback:', scrs[_j].src.split('?')[1]);
          return;
        }
      }
    }, { once: true });
  })();

  // ar55.14: UI freeze fix — ağır sync işlemler arasında tarayıcıya nefes bırak.
  // setTimeout(0) ile event loop'a dönülür → modal render edilir, spinner döner.
  function yieldToUI(ms) { return new Promise(function(r) { setTimeout(r, ms || 0); }); }

  // Build version — tarayıcı doğru sürümü çalıştırıyor mu kontrol için.
  // Eski version görüyorsanız hard refresh (Ctrl+Shift+R) yapın.
  var DVB_AR_VERSION = 'ar58.0-2026-08-07-real-world-occlusion';
  console.log('[DVB-AR] script loaded:', DVB_AR_VERSION);
  window.__DVB_AR_VERSION__ = DVB_AR_VERSION;

  // ar34: QR URL version guard. QR URL'ye bu versiyonu ekle.
  // Telefon farklı versiyonda üretilmiş QR açınca → hash ignore, yeni model üret.
  // Bu sayede ar32 döneminde üretilen tüm bozuk QR'lar otomatik geçersiz olur.
  var CACHE_VERSION = 'ar58.0-2026-08-07-real-world-occlusion-' + Date.now();

  // ═══════════════════ KONFİG ═══════════════════
  var WHITELIST = ['paradiso-plus', 'paradiso plus', 'paradiso']; // ar14: artık kullanılmıyor (isWhitelisted hep true döner). İleride kalite exclude için referans olarak duruyor.
  // ar48: resolveCarpetThicknessMM — ürünün gerçek hav yüksekliğini bul.
  // Sıra: 1) Shopify metafield (pile/thickness/hav), 2) açıklama metni regex,
  // 3) varsayılan 4mm. Sonuç {mm, source} döner. 3-25 mm clamp.
  // Range ("3 mm - 16 mm") açıklamada bulunursa: ürünün kendi tekil değeri yoksa
  // ÜST sınır alınır (kullanıcı görsel olarak en kalın halini bekler).
  // Global expose — webxr-ar-assistant.js gibi diğer scriptlerin de aynı yardımcıyı
  // kullanabilmesi için.
  if (typeof window !== 'undefined') {
    setTimeout(function(){ try { window.__dvbResolveCarpetThicknessMM__ = resolveCarpetThicknessMM; } catch(_e){} }, 0);
  }
  function resolveCarpetThicknessMM(productData) {
    var DEFAULT_MM = 4;
    var MIN_MM = 3, MAX_MM = 25;
    var pd = productData || (typeof window !== 'undefined' && window.productData) || {};
    function clamp(v) { return Math.max(MIN_MM, Math.min(MAX_MM, v)); }
    function parseSingle(str) {
      // "12 mm", "12mm", "12,5 mm", "8.0 mm"
      var m = String(str).match(/(\d+(?:[.,]\d+)?)\s*mm\b/i);
      if (!m) return null;
      var v = parseFloat(m[1].replace(',', '.'));
      return isFinite(v) ? v : null;
    }
    function parseRange(str) {
      // "3 mm - 16 mm", "3-16 mm", "3 mm – 16 mm"
      var m = String(str).match(/(\d+(?:[.,]\d+)?)\s*(?:mm)?\s*[-–—]\s*(\d+(?:[.,]\d+)?)\s*mm\b/i);
      if (!m) return null;
      var lo = parseFloat(m[1].replace(',', '.'));
      var hi = parseFloat(m[2].replace(',', '.'));
      return (isFinite(lo) && isFinite(hi) && hi > lo) ? { lo: lo, hi: hi } : null;
    }
    // 1) Metafield (öncelikli — ürün başına tekil ve doğru kabul)
    if (pd.metafields) {
      var fields = ['pile', 'thickness', 'hav', 'hav_yuksekligi', 'kalinlik'];
      for (var i = 0; i < fields.length; i++) {
        var raw = pd.metafields[fields[i]];
        if (raw == null) continue;
        var v = parseSingle(raw);
        if (v == null) {
          // metafield "12" gibi sade sayı olabilir
          var m2 = String(raw).match(/^\s*(\d+(?:[.,]\d+)?)\s*$/);
          if (m2) v = parseFloat(m2[1].replace(',', '.'));
        }
        if (v != null) return { mm: clamp(v), source: 'metafield:' + fields[i], raw: String(raw) };
      }
    }
    // 2) Açıklama metni (description / body_html). Anahtar kelimeyle yakındaki mm değerini bul.
    var desc = String(pd.description || pd.body_html || pd.html || '').replace(/<[^>]+>/g, ' ');
    if (desc) {
      // Önce anahtar kelime + tekil mm yakınlığı: "kalınlık 12 mm", "Hav yüksekliği: 8mm"
      var keyRe = /(kalınlık|kalinlik|hav\s*y(ü|u)ksekli(ğ|g)i|pile\s*height|pile)\s*[:\-–—]?\s*(\d+(?:[.,]\d+)?)\s*mm\b/i;
      var km = desc.match(keyRe);
      if (km && km[4]) {
        // ar48b: km[5]→km[4]. Capture grupları: 1=keyword, 2=ü|u, 3=ğ|g, 4=mm değeri.
        var kv = parseFloat(String(km[4]).replace(',', '.'));
        if (isFinite(kv)) return { mm: clamp(kv), source: 'description:keyword', raw: km[0].trim() };
      }
      // Sonra range: "3 mm - 16 mm" → üst sınır
      var rng = parseRange(desc);
      if (rng) {
        console.log('[AR] thickness range bulundu, üst sınır kullanılıyor:', rng);
        return { mm: clamp(rng.hi), source: 'description:range-upper', raw: rng.lo + '-' + rng.hi + ' mm' };
      }
      // Son çare: tek başına ilk mm değeri
      var sv = parseSingle(desc);
      if (sv != null) return { mm: clamp(sv), source: 'description:any-mm', raw: sv + ' mm' };
    }
    // 3) Varsayılan
    return { mm: DEFAULT_MM, source: 'default', raw: DEFAULT_MM + ' mm' };
  }
  // Yardımcı: meters döndürür ve console'a kaynak log'lar.
  function resolveThicknessMeters(preset, productData) {
    var info = resolveCarpetThicknessMM(productData);
    var mm = info.mm;
    // preset.thickness override (per-quality preset değeri varsa kullan, ama sadece
    // metafield/description bulunamadığında — kullanıcı açıklamasındaki değer
    // her zaman preset varsayılanından önce gelir).
    if (info.source === 'default' && preset && typeof preset.thickness === 'number') {
      mm = Math.max(3, Math.min(25, preset.thickness * 1000));
      info = { mm: mm, source: 'preset', raw: preset.thickness + ' m' };
    }
    try { window.__DVB_AR_LAST_THICKNESS__ = info; } catch(_e){}
    console.log('[AR] thickness:', info.mm + 'mm', '(' + info.source + ')', info.raw);
    return mm / 1000; // meters
  }
  // Bevel ölçeklemesi: ince halıda küçük bevel, kalın halıda yüksek bevel limit.
  // Kural: bevelSize < thickness/2 (geometry self-intersect engelle).
  // 4mm halı → ~1.8mm, 10mm → ~4mm, 16mm → ~6.4mm bevel.
  function computeBevelSize(thicknessM) {
    return Math.min(thicknessM * 0.4, 0.0064);
  }
  // Grain noise (hav doku) ölçeklemesi: ince halıda düz, kalın halıda belirgin.
  function grainScaleFromThickness(thicknessM) {
    var mm = thicknessM * 1000;
    if (mm <= 4) return 0.6;       // ince kilim → düz
    if (mm <= 9) return 1.0;       // klasik halı → mevcut
    return 1.5;                     // shaggy/kalın → belirgin hav
  }
  var THICKNESS_M = 0.004; // ar26: 12mm → 4mm. Gerçek halı hav yüksekliği 12mm
                            // ama AR'da Quick Look auto-shadow zayıf + side wall belirgin
                            // → halı "havada" görünüyor. 4mm görsel olarak daha doğal
                            // temas hissi veriyor (kullanıcı geri bildirimi: ar25 sonrası
                            // halı ~10cm yüksekte gibi duruyor — gölgesizliğin kombinasyonu).
  var TEXTURE_TARGET_PX = 2560; // ar49: 2048→2560. Daha yüksek texture rez, açılı bakışlarda da net.
  // 1024 is the official Three.js USDZExporter r160 texture contract; it applies only to auxiliary PBR maps.
  // The product colour texture remains native-resolution in GLB and 2560 on iPhone.
  var PBR_MAP_TARGET_PX = 1024;

  // ar49: Texture'ı tutarlı şekilde konfigüre eden tek nokta — tüm pipeline kullanır.
  // Hem GLB hem USDZ tarafında aynı filtering (LinearMipmapLinear) ve anisotropy.
  // Bu sayede halıya açılı bakıldığında (AR'da kullanıcı eğilince) texture bulanıklaşmaz.
  function configureTexture(THREE, tex) {
    tex.colorSpace = THREE.SRGBColorSpace || 'srgb';
    tex.needsUpdate = true;
    tex.anisotropy = 16;
    tex.wrapS = THREE.ClampToEdgeWrapping;
    tex.wrapT = THREE.ClampToEdgeWrapping;
    tex.minFilter = THREE.LinearMipmapLinearFilter;
    tex.magFilter = THREE.LinearFilter;
    tex.generateMipmaps = true;
    return tex;
  }
  var THREE_VER = '0.180.0';
  // API base — kullanıcı production'da window.__AR_API_BASE__ ile override edebilir
  var DEFAULT_API_BASE = 'https://dolcevita-ar.haydarerkaya.workers.dev';
  var API_BASE = (window.__AR_API_BASE__ || DEFAULT_API_BASE).replace(/\/+$/, '');

  // PBR materyal preset (kalite başına çoğaltılabilir şablon)
  var MATERIAL_PRESETS = {
    // ar28: Her kalite için ayrı doku/material parametreleri.
    // normalScale: halı havı derinliği (yüksek = daha belirgin doku).
    // grainAmp: texture grain noise genliği (±grainAmp/2 luminance, pixel seviyesi).
    // contrastBoost: texture kontrast çarpanı (body ortalama etrafında).
    // Gerçek halı luminance std=47, AR texture std~5 → boost+grain bu farkı kapatır.
    'paradiso-plus': {
      label: 'Paradiso Plus',
      thickness: 0.0003,      // ar44: 0.8mm→0.3mm. Side wall görünmez kadar ince → halı altında "siyah çizgi" yok.
      topRoughness: 0.88,     // ar49: 0.97→0.88. Daha az mat → orijinal görsel renkleri canlı yansır.
      topMetalness: 0.0,
      sideColor: 0x2a1f17,
      sideRoughness: 0.98,
      normalScale: 1.2,       // ar49: 1.5→1.2. Yüksek normal scale + low source rez = noise. Daha temiz.
      grainAmp: 38,           // ar49: 58→38. Adaptive (kaynak std≥35 ise zaten 0).
      contrastBoost: 1.35,    // ar49: 1.85→1.35. Sönük film yapan "aşırı boost" azaltıldı.
    },
  };

  // ═══════════════════ STATE ═══════════════════
  var inited = false;
  var threeMods = null;          // {THREE, GLTFExporter, USDZExporter}
  var qrLib = null;              // qrcode lib
  var modelViewerReady = false;
  var lastResult = null;         // {hash, glb, usdz}
  // ar55.10: Pipeline kilidi — dvbArShowForCartItem paralel çağrılarını önler.
  // closeModal() çağrısında sıfırlanır.
  var _arPipelineLock = false;

  // ════���══════════════ KALİTE TESPİTİ ═══════════════════
  function detectQualityCode() {
    try {
      // 1. window.__OZEL_OLCU_CONFIG__ (banner-product akışı)
      var cfg = window.__OZEL_OLCU_CONFIG__ || {};
      var qc = (cfg.qualityCode || '').toString().toLowerCase().trim();
      if (qc) return qc;
      // 2. __ALL_CONFIGS__'dan currentProductKey -> qualityCode
      var all = window.__ALL_CONFIGS__ || {};
      var products = all.products || all;
      var handle = (document.getElementById('banner-product') || {}).dataset?.productHandle || '';
      if (handle && products) {
        var keys = Object.keys(products);
        for (var i = 0; i < keys.length; i++) {
          var p = products[keys[i]];
          if (!p) continue;
          var hs = p.shopifyHandles || {};
          if (hs.biye === handle || hs.bordur === handle || hs.overlok === handle || p.shopifyHandle === handle) {
            return (p.qualityCode || '').toString().toLowerCase().trim();
          }
        }
      }
    } catch (e) {}
    // ar30: qualityCode bulunamazsa 'paradiso-plus' fallback → tüm ürünlerde buton görünür.
    // Material preset fallback her halıda görsel olarak yeterli.
    return 'paradiso-plus';
  }

  function isWhitelisted(qc) {
    // ar30: qualityCode her zaman var (en kötü ihtimal 'paradiso-plus' fallback).
    // Tüm ürünlerde AR aktif.
    return true;
  }

  // ═══════════════════ UI: BUTTON + MODAL ═══════════════════
  function injectStyles() {
    if (document.getElementById('dvb-ar-modal-styles')) return;
    var s = document.createElement('style');
    s.id = 'dvb-ar-modal-styles';
    s.textContent = [
      '.dvb-ar-btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;width:100%;margin-top:10px;padding:13px 18px;background:linear-gradient(135deg,#1f1f23 0%,#2d2d35 100%);color:#fff;border:1px solid #3a3a44;border-radius:10px;font-size:14px;font-weight:600;letter-spacing:.3px;cursor:pointer;transition:transform .15s,box-shadow .2s,filter .2s;font-family:inherit;-webkit-tap-highlight-color:transparent;}',
      '.dvb-ar-btn:hover{transform:translateY(-1px);box-shadow:0 6px 18px rgba(0,0,0,.18);filter:brightness(1.08);}',
      '.dvb-ar-btn:active{transform:translateY(0);}',
      '.dvb-ar-btn[disabled]{opacity:.5;cursor:not-allowed;transform:none;}',
      '.dvb-ar-btn__ico{width:18px;height:18px;display:inline-block;}',
      '.dvb-ar-btn__hint{font-size:11px;font-weight:500;opacity:.75;margin-left:auto;letter-spacing:.5px;text-transform:uppercase;}',
      '.dvb-ar-modal{position:fixed;inset:0;background:rgba(15,15,20,.78);backdrop-filter:blur(6px);z-index:2147483647;display:none;align-items:center;justify-content:center;padding:20px;animation:dvb-ar-fade .2s ease;}',
      '.dvb-ar-modal.open{display:flex;}',
      '@keyframes dvb-ar-fade{from{opacity:0}to{opacity:1}}',
      '.dvb-ar-modal__box{background:#fff;border-radius:14px;max-width:520px;width:100%;max-height:90vh;overflow:auto;box-shadow:0 24px 60px rgba(0,0,0,.4);position:relative;}',
      '.dvb-ar-modal__close{position:absolute;top:10px;right:10px;width:34px;height:34px;border:none;background:rgba(0,0,0,.05);border-radius:50%;cursor:pointer;font-size:18px;line-height:1;color:#333;display:flex;align-items:center;justify-content:center;z-index:2;}',
      '.dvb-ar-modal__close:hover{background:rgba(0,0,0,.1);}',
      '.dvb-ar-modal__header{padding:20px 24px 8px;border-bottom:1px solid #f0f0f0;}',
      '.dvb-ar-modal__title{font-size:16px;font-weight:700;color:#1a1a1a;margin:0 0 4px;}',
      '.dvb-ar-modal__sub{font-size:12px;color:#777;margin:0;}',
      '.dvb-ar-modal__body{padding:18px 24px 24px;}',
      '.dvb-ar-loading{display:flex;flex-direction:column;align-items:center;gap:14px;padding:28px 16px;}',
      '.dvb-ar-spin{width:38px;height:38px;border:3px solid #eee;border-top-color:#e8622a;border-radius:50%;animation:dvb-ar-spin 0.8s linear infinite;}',
      '@keyframes dvb-ar-spin{to{transform:rotate(360deg);}}',
      '.dvb-ar-status{font-size:13px;color:#555;text-align:center;line-height:1.4;}',
      '.dvb-ar-status strong{color:#1a1a1a;}',
      '.dvb-ar-error{background:#fef2f2;border:1px solid #fecaca;color:#991b1b;padding:14px 16px;border-radius:10px;font-size:13px;line-height:1.5;}',
      '.dvb-ar-mv{width:100%;height:380px;background:linear-gradient(145deg,#fafafa,#f0f0f0);border-radius:10px;display:block;}',
      '.dvb-ar-qr-block{display:flex;gap:18px;align-items:center;margin-top:18px;padding:16px;background:#f9f7f4;border-radius:10px;}',
      '.dvb-ar-qr-img{width:130px;height:130px;background:#fff;padding:8px;border-radius:8px;border:1px solid #eee;flex-shrink:0;}',
      '.dvb-ar-qr-text{font-size:13px;color:#444;line-height:1.45;}',
      '.dvb-ar-qr-text strong{display:block;font-size:14px;color:#1a1a1a;margin-bottom:4px;}',
      '.dvb-ar-mobile-cta{display:block;width:100%;margin-top:14px;padding:14px;background:#e8622a;color:#fff;border:none;border-radius:10px;font-size:15px;font-weight:600;cursor:pointer;text-align:center;text-decoration:none;}',
      '.dvb-ar-mobile-cta:hover{background:#d05423;}',
      '@media(max-width:520px){.dvb-ar-modal{padding:8px;}.dvb-ar-modal__box{max-height:96vh;border-radius:10px;}.dvb-ar-mv{height:300px;}.dvb-ar-qr-block{flex-direction:column;text-align:center;}}',
      '@keyframes dvb-ar-float{0%,100%{transform:translateY(0) rotateX(15deg) rotateY(-12deg)}50%{transform:translateY(-9px) rotateX(15deg) rotateY(12deg)}}',
      '.dvb-ar-rug-stage{position:relative;height:120px;margin:12px 0 4px;perspective:900px;display:flex;align-items:center;justify-content:center;overflow:hidden;}',
      '.dvb-ar-rug-stage::before{content:"";position:absolute;bottom:14px;left:50%;width:84px;height:12px;border-radius:50%;background:radial-gradient(ellipse at center,rgba(0,0,0,.22) 0%,rgba(0,0,0,0) 70%);transform:translateX(-50%);filter:blur(2px);pointer-events:none;}',
      '.dvb-ar-rug-stage__rug{width:60px;height:84px;background-size:cover;background-position:center;background-color:#e8dec9;border-radius:3px;box-shadow:0 10px 24px rgba(0,0,0,.22),0 3px 8px rgba(0,0,0,.14);animation:dvb-ar-float 3.6s ease-in-out infinite;transform-style:preserve-3d;will-change:transform;}',
      '.dvb-ar-rug-stage__rug.tilting{animation:none;transition:transform .12s ease-out;}',
      '.dvb-ar-rug-stage[data-empty="1"] .dvb-ar-rug-stage__rug{background-image:linear-gradient(135deg,#e8dec9 0%,#d4c8ad 100%);}',
      // ar55: modal stage video modu — ürün galerisinde video varsa sallanan halı yerine oynar.
      '.dvb-ar-rug-stage__video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;border-radius:8px;background:#0a0a0a;display:none;}',
      '.dvb-ar-rug-stage[data-mode="video"]::before{display:none;}',
      '.dvb-ar-rug-stage[data-mode="video"] .dvb-ar-rug-stage__rug{display:none;}',
      '.dvb-ar-rug-stage[data-mode="video"] .dvb-ar-rug-stage__video{display:block;}',
      '.dvb-ar-cards{margin:14px 0 0;padding:14px 16px 10px;background:#fafafa;border-radius:10px;border:1px solid #f0f0f0;}',
      '.dvb-ar-card{min-height:108px;display:flex;flex-direction:column;justify-content:center;animation:dvb-ar-card-in .4s ease;}',
      '@keyframes dvb-ar-card-in{from{opacity:0;transform:translateY(8px);}to{opacity:1;transform:translateY(0);}}',
      '.dvb-ar-card.fade-out{animation:dvb-ar-card-out .35s ease forwards;}',
      '@keyframes dvb-ar-card-out{from{opacity:1;transform:translateY(0);}to{opacity:0;transform:translateY(-8px);}}',
      '.dvb-ar-card__title{font-size:11px;color:#888;font-weight:500;letter-spacing:.5px;text-transform:uppercase;margin:0 0 8px;}',
      '.dvb-ar-card__body{font-size:14px;color:#1a1a1a;line-height:1.55;}',
      '.dvb-ar-card__body strong{color:#0a0a0a;font-weight:600;}',
      '.dvb-ar-card__feat{display:grid;grid-template-columns:auto 1fr;gap:7px 12px;font-size:13px;line-height:1.4;}',
      '.dvb-ar-card__feat-key{color:#888;}',
      '.dvb-ar-card__feat-val{color:#1a1a1a;font-weight:500;}',
      '.dvb-ar-card__price-main{font-size:22px;font-weight:700;color:#1a1a1a;display:block;margin-bottom:4px;letter-spacing:-.3px;}',
      '.dvb-ar-card__price-sub{font-size:13px;color:#555;}',
      '.dvb-ar-card__discount{display:inline-block;background:#fde8e8;color:#c92a2a;font-size:11px;font-weight:600;padding:3px 9px;border-radius:4px;margin-top:8px;letter-spacing:.2px;}',
      '.dvb-ar-card__perks{display:flex;flex-direction:column;gap:9px;font-size:13px;color:#333;}',
      '.dvb-ar-card__perk{display:flex;align-items:center;gap:9px;line-height:1.35;}',
      '.dvb-ar-card__perk-ico{width:18px;height:18px;flex-shrink:0;color:#1a8870;}',
      '.dvb-ar-card__stock{color:#c92a2a;font-weight:600;}',
      '.dvb-ar-dots{display:flex;justify-content:center;gap:6px;margin-top:12px;}',
      '.dvb-ar-dot{width:6px;height:6px;border-radius:50%;background:#ddd;cursor:pointer;transition:all .25s ease;border:none;padding:0;}',
      '.dvb-ar-dot.active{background:#1a1a1a;width:20px;border-radius:3px;}',
      '.dvb-ar-loading-mini{font-size:13.5px;font-weight:500;color:#2a2a2a;margin-top:14px;display:flex;align-items:center;justify-content:center;gap:10px;background:#f5f3ef;border-left:3px solid #e8622a;border-radius:0 8px 8px 0;padding:11px 14px;line-height:1.4;}',
      '.dvb-ar-spin-mini{width:15px;height:15px;border:2.5px solid #ddd;border-top-color:#e8622a;border-radius:50%;animation:dvb-ar-spin .8s linear infinite;flex-shrink:0;}',
      '@media(max-width:520px){.dvb-ar-cards{padding:12px 14px 8px;}.dvb-ar-card{min-height:94px;}.dvb-ar-card__price-main{font-size:19px;}}',
            '@media(max-width:520px){.dvb-ar-rug-stage{height:100px;}.dvb-ar-rug-stage__rug{width:48px;height:68px;}}',
    ].join('\n');
    document.head.appendChild(s);
  }

  function injectButton() {
    // ar54.1: Normal ürün sayfalarında gri buton gizlendi — V5 (theme.liquid) siyah buton ekler.
    // ar55.5: Ancak V5 scripti "unless product.handle contains 'ozel'" koşuluyla özel ölçü
    // sayfalarında ÇALIŞMIYOR. Bu sayfalar için siyah butonu biz enjekte etmeliyiz.

    // V5'in zaten eklediği siyah buton varsa hiçbir şey yapma.
    if (document.getElementById(EAGER_BTN_ID)) return;

    // Özel ölçü sayfası değilse V5 halleder — dokunma.
    if (!/ozel.olcu/i.test(window.location.pathname)) return;

    // Zaten enjekte ettikse tekrar ekleme.
    if (document.getElementById('dvb-ar-btn')) return;

    // Özel ölçü form container'ını bul.
    var container = (
      document.getElementById('ozel-olcu-plus') ||
      document.getElementById('banner-product') ||
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('.product-form') ||
      document.querySelector('.product')
    );
    if (!container) return;

    // Siyah buton — V5 ile aynı görünüm + aynı ID (bindEagerModalOpen bulabilsin).
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = EAGER_BTN_ID; // dvb-ar-product-btn
    btn.innerHTML =
      '<span style="font-size:14px;font-weight:600;display:block;line-height:1.2;letter-spacing:.3px;">Halıyı Odanızda Canlı Görün</span>' +
      '<span style="font-size:11px;font-weight:400;opacity:.65;letter-spacing:.6px;display:block;margin-top:3px;line-height:1.2;">AR teknolojisi · 1:1 ölçekte önizleme</span>';
    btn.style.cssText = 'display:block!important;width:100%;margin-top:10px;padding:11px 18px;background:linear-gradient(135deg,#1a1a1f 0%,#2a2a33 100%);color:#fff;border:1px solid #2d2d35;border-radius:8px;cursor:pointer;text-align:center;transition:transform .18s ease,box-shadow .18s ease,filter .18s ease;font-family:inherit;-webkit-tap-highlight-color:transparent;box-shadow:0 1px 2px rgba(0,0,0,.06);';
    btn.addEventListener('mouseenter', function () { this.style.transform = 'translateY(-1px)'; this.style.boxShadow = '0 6px 18px rgba(0,0,0,.18)'; this.style.filter = 'brightness(1.08)'; });
    btn.addEventListener('mouseleave', function () { this.style.transform = ''; this.style.boxShadow = '0 1px 2px rgba(0,0,0,.06)'; this.style.filter = ''; });
    // Özel ölçü sayfasında onArClick kullan — width/length DOM'dan okur.
    btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); onArClick(); });
    container.appendChild(btn);
    bindEagerModalOpen(); // Yeni eklenen butona capture listener bağla.
    console.log('[AR] özel ölçü sayfası — siyah buton enjekte edildi');
    updateButtonState();
  }

  function updateButtonState() {
    var btn = document.getElementById('dvb-ar-btn') || document.getElementById(EAGER_BTN_ID);
    if (!btn) return;
    // ar55.10: Normal ürün sayfalarında (V5 yönetir) butona dokunma — ozel-olcu
    // input'ları yoktur, NaN > 0 = false → btn.disabled=true → tıklama çalışmaz.
    if (!/ozel.olcu/i.test(window.location.pathname)) return;
    var w = parseFloat((document.getElementById('ozel-olcu-width') || {}).value);
    var h = parseFloat((document.getElementById('ozel-olcu-length') || {}).value);
    var ok = w > 0 && h > 0;
    // ar29: QR/URL hash ile gelinmişse buton her zaman aktif — state URL'den alınır
    if (!ok && new URLSearchParams(location.search).get('h')) ok = true;
    // ar55.15: btn.disabled HTML attribute'u tarayıcının click event'ini tamamen
    // bloke eder — onArClick hiç çağrılmaz, modal açılmaz, kullanıcı bir şey görmez.
    // Çözüm: disabled attribute KULLANMA. Görsel ipucu (opacity) yeterli.
    // generateAndShow() zaten "Önce halı ölçülerini girin" hatasını modal içinde gösterir.
    btn.disabled = false; // ASLA disabled yapma — click event'i öldürür
    btn.title = ok ? 'AR ile evimde gör' : 'Önce ölçü girin (en ve boy)';
    btn.style.opacity = ok ? '1' : '0.65';
    btn.style.cursor = ok ? '' : 'not-allowed';
  }

  function ensureModal() {
    var m = document.getElementById('dvb-ar-modal');
    if (m) return m;
    m = document.createElement('div');
    m.id = 'dvb-ar-modal';
    m.className = 'dvb-ar-modal';
    m.innerHTML =
      '<div class="dvb-ar-modal__box">' +
        '<button type="button" class="dvb-ar-modal__close" aria-label="Kapat">×</button>' +
        '<div class="dvb-ar-modal__header">' +
          '<h3 class="dvb-ar-modal__title">Halıyı Evinizde Görün</h3>' +
          '<p class="dvb-ar-modal__sub">Telefonunuzun kamerasıyla halıyı 1:1 ölçekte yerleştirin.</p>' +
          '<div class="dvb-ar-rug-stage" id="dvb-ar-rug-stage" data-empty="1">' +
            '<div class="dvb-ar-rug-stage__rug" id="dvb-ar-rug"></div>' +
            // ar55: video element (ürün videosu varsa rug yerine oynar)
            // ar55.2: autoplay + preload=auto — iOS Safari için tüm attribute'lar HTML üzerinde de set edilmeli.
            '<video class="dvb-ar-rug-stage__video" id="dvb-ar-video" muted autoplay playsinline loop preload="auto" disableremoteplayback webkit-playsinline></video>' +
          '</div>' +
        '</div>' +
        '<div class="dvb-ar-modal__body" id="dvb-ar-body"></div>' +
      '</div>';
    document.documentElement.appendChild(m);
    m.addEventListener('click', function (e) {
      if (e.target === m) closeModal();
    });
    m.querySelector('.dvb-ar-modal__close').addEventListener('click', closeModal);
    return m;
  }

  function openModal() {
    var m = ensureModal();
    // ar55.10b: V5 closeModal() m.style.display='none' inline style bırakabiliyor.
    // classList.add('open') tek başına CSS'i override edemez → sıfırla.
    m.style.display = '';
    m.classList.add('open');
    // ar55: önce ürün videosunu dene; yoksa eski sallanan halı görseli akışına dön.
    if (!setRugVideo()) {
      setRugImage();
      bindRugTilt();
      // ar55.9: video DOM'da yok (lazy-load) → /products/HANDLE.js async XHR ile video çek.
      // ar55.13: özel ölçü koşulu kaldırıldı — tüm ürün sayfalarında çalışır.
      fetchOzelOlcuVideoAsync();
    }
  }

  // ar55: Shopify ürün galerisinden ilk video src'ini bul. Önce DOM (Dawn/HDT/Impulse
  // varyantları + jenerik), sonra window.productData.media fallback'i. External video
  // (YouTube/Vimeo iframe) görmezden gelinir — autoplay+muted garantisi yok.
  function findProductVideoSrc() {
    var sels = [
      '.hdt-product__media-item video', '.hdt-slider__slide video',
      '.hdt-main-product__media video', '.product-single__photo video',
      '.product__media video', '[data-media-type="video"] video',
      '[data-product-media-type="video"] video', 'product-model video',
      'video[src*="cdn.shopify"]', 'video[src*=".mp4"]'
    ];
    for (var i = 0; i < sels.length; i++) {
      var els = document.querySelectorAll(sels[i]);
      for (var k = 0; k < els.length; k++) {
        var v = els[k];
        if (v.id === 'dvb-ar-video') continue;
        // currentSrc (oynatılan), src attribute, data-src (lazy-load), source child (tümü dene)
        var src = v.currentSrc || v.getAttribute('src') || v.getAttribute('data-src') || '';
        if (!src) {
          var sr = v.querySelector && (
            v.querySelector('source[src]') ||
            v.querySelector('source[data-src]')
          );
          if (sr) src = sr.getAttribute('src') || sr.getAttribute('data-src') || '';
        }
        if (src && /^https?:|^\/\//.test(src)) return src;
      }
    }
    try {
      var pd = window.productData || window.__product || {};
      var media = pd.media || (pd.product && pd.product.media);
      if (media && media.length) {
        for (var j = 0; j < media.length; j++) {
          var m = media[j];
          var mt = m && (m.media_type || m.type);
          if (mt === 'video' && m.sources && m.sources.length) {
            for (var s = 0; s < m.sources.length; s++) {
              var so = m.sources[s];
              if (so && so.mime_type && so.mime_type.indexOf('mp4') !== -1) return so.url;
            }
            if (m.sources[0] && m.sources[0].url) return m.sources[0].url;
          }
        }
      }
    } catch (_e) {}
    return null;
  }

  function setRugVideo() {
    var v = document.getElementById('dvb-ar-video');
    var stage = document.getElementById('dvb-ar-rug-stage');
    if (!v || !stage) return false;
    var src = findProductVideoSrc();
    if (!src) return false;
    // iOS Safari muted autoplay: muted + playsinline attribute set BEFORE src.
    v.muted = true;
    v.loop = true;
    v.playsInline = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');
    if (v._dvbSrc !== src) {
      v._dvbSrc = src;
      v.src = src;
      try { v.load(); } catch(_e){}
    }
    // Önceki autoplay-fallback'inden kalan inline display:none'u temizle.
    v.style.display = '';
    stage.setAttribute('data-mode', 'video');
    stage.removeAttribute('data-empty');

    // ar55.2: play() hem src yüklendikten sonra hem de doğrudan dene (iOS user gesture context).
    function tryPlay() {
      try {
        var p = v.play();
        if (p && p.catch) p.catch(function(err){
          console.warn('[AR] video autoplay reddedildi, görsel fallback:', err && err.message);
          stage.removeAttribute('data-mode');
          v.style.display = 'none';
          setRugImage(); bindRugTilt();
        });
      } catch(_e){}
    }

    if (v.readyState >= 2) {
      // Video data zaten yüklü — hemen oynat.
      tryPlay();
    } else {
      // Veri yüklenince oynat (loadeddata = ilk kare hazır).
      v.addEventListener('loadeddata', tryPlay, { once: true });
      // Yedek: canplay event'i de dene (bazı tarayıcılarda loadeddata tetiklenmez).
      v.addEventListener('canplay', tryPlay, { once: true });
      // Timeout fallback: 1.5sn içinde data gelmezse sallanan halıya dön.
      var _fbTimer = setTimeout(function() {
        if (v.readyState < 2) {
          console.warn('[AR] video yüklenemedi, görsel fallback');
          stage.removeAttribute('data-mode');
          v.style.display = 'none';
          setRugImage(); bindRugTilt();
        }
      }, 1500);
      v.addEventListener('loadeddata', function(){ clearTimeout(_fbTimer); }, { once: true });
    }

    console.log('[AR] modal video oynatılıyor:', src);
    return true;
  }

  // ar55.9: Özel ölçü sayfalarında ürün videosu DOM'da yok (lazy-load) ve
  // theme.liquid V5 bu sayfalarda çalışmıyor → setRugVideo() null döner.
  // Base ürün handle'ından /products/HANDLE.js XHR ile video URL çek; modal
  // hâlâ açıksa uygula. Aynı handle için cache'le (sayfa boyunca tek XHR).
  var _dvbOzelOlcuVideoCache = window._dvbOzelOlcuVideoCache ||
    (window._dvbOzelOlcuVideoCache = {});

  // Biye/bordür/overlok handle'larını base ürün shopifyHandle'ına çevirir.
  function detectOzelOlcuBaseHandle() {
    try {
      var bp = document.getElementById('banner-product');
      var bpHandle = (bp && bp.dataset && bp.dataset.productHandle) || '';
      var all = window.__ALL_CONFIGS__ || {};
      var products = all.products || all;
      if (bpHandle && products && typeof products === 'object') {
        var keys = Object.keys(products);
        for (var i = 0; i < keys.length; i++) {
          var p = products[keys[i]];
          if (!p) continue;
          var hs = p.shopifyHandles || {};
          // Biye/bordür/overlok variant ise base handle'a yükselt.
          if (hs.biye === bpHandle || hs.bordur === bpHandle || hs.overlok === bpHandle) {
            return p.shopifyHandle || bpHandle;
          }
          if (p.shopifyHandle === bpHandle) return bpHandle;
        }
      }
      // __OZEL_OLCU_CONFIG__.shopifyHandle'ı ham bpHandle'dan önce dene:
      // bpHandle biye/bordür/overlok variant'ı olabilir; config ise base ürünü gösterir.
      var cfg = window.__OZEL_OLCU_CONFIG__ || {};
      if (cfg.shopifyHandle) return cfg.shopifyHandle;
      return bpHandle || null;
    } catch (_e) {}
    return null;
  }

  // ar55.13: Tüm ürün sayfaları için genelleştirildi (özel ölçü + normal ürün sayfaları).
  // Önceki versiyon yalnızca /ozel-olcu/ yolunda çalışıyordu; V5 akışındaki normal
  // ürün sayfaları (ör. kesme ürünler) video DOM'a lazy-load edildiği için
  // findProductVideoSrc() bulamıyordu ve XHR da atılmıyordu → modal'da hep görsel.
  // Çözüm: önce özel ölçü base handle'ı dene, yoksa URL'den handle al.
  function fetchOzelOlcuVideoAsync() {
    // 1. Özel ölçü sayfası: banner-product + __ALL_CONFIGS__ üzerinden base handle.
    var handle = detectOzelOlcuBaseHandle();
    // 2. Normal ürün sayfası (V5 akışı): /products/HANDLE yolundan handle al.
    if (!handle) {
      var pathParts = window.location.pathname.split('/products/');
      if (pathParts.length > 1) {
        var rawHandle = pathParts[1].split('/')[0];
        if (rawHandle) handle = decodeURIComponent(rawHandle);
      }
    }
    if (!handle) {
      console.log('[AR] async video: handle tespit edilemedi');
      return;
    }
    // Cache hit: daha önce çekildiyse hemen uygula.
    if (_dvbOzelOlcuVideoCache[handle] !== undefined) {
      if (_dvbOzelOlcuVideoCache[handle]) applyOzelOlcuVideoSrc(_dvbOzelOlcuVideoCache[handle]);
      return;
    }
    // In-flight marker: paralel XHR'ı engelle.
    _dvbOzelOlcuVideoCache[handle] = null;
    console.log('[AR] async video: /products/' + handle + '.js çekiliyor');
    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/products/' + handle + '.js', true);
    xhr.onload = function() {
      if (xhr.status !== 200) {
        // non-200: in-flight null'ı temizle → sonraki modal açılışında tekrar denenebilir.
        if (_dvbOzelOlcuVideoCache[handle] === null) delete _dvbOzelOlcuVideoCache[handle];
        console.warn('[AR] async video: HTTP ' + xhr.status + ' /products/' + handle + '.js');
        return;
      }
      try {
        var data = JSON.parse(xhr.responseText);
        var media = data.media || [];
        for (var i = 0; i < media.length; i++) {
          var m = media[i];
          if (m && m.media_type === 'video' && m.sources && m.sources.length) {
            var videoUrl = null;
            for (var s = 0; s < m.sources.length; s++) {
              var so = m.sources[s];
              if (so && so.mime_type && so.mime_type.indexOf('mp4') !== -1) {
                videoUrl = so.url; break;
              }
            }
            if (!videoUrl && m.sources[0] && m.sources[0].url) videoUrl = m.sources[0].url;
            if (videoUrl) {
              _dvbOzelOlcuVideoCache[handle] = videoUrl;
              applyOzelOlcuVideoSrc(videoUrl);
              return;
            }
          }
        }
        // Video yoksa cache'e '' yaz (tekrar XHR atılmasın, null in-flight ile karışmasın).
        if (_dvbOzelOlcuVideoCache[handle] === null) _dvbOzelOlcuVideoCache[handle] = '';
        console.log('[AR] async video: /products/' + handle + '.js içinde video bulunamadı');
      } catch (_e) { console.warn('[AR] async video parse hatası', _e); }
    };
    xhr.onerror = function() {
      // Ağ hatası: in-flight null'ı temizle → sonraki modal açılışında tekrar denenebilir.
      if (_dvbOzelOlcuVideoCache[handle] === null) delete _dvbOzelOlcuVideoCache[handle];
      console.warn('[AR] async video XHR hatası');
    };
    xhr.send();
  }

  // Modal hâlâ açıksa ve sallanan halı modundaysa video src uygular.
  function applyOzelOlcuVideoSrc(src) {
    var v = document.getElementById('dvb-ar-video');
    var stage = document.getElementById('dvb-ar-rug-stage');
    if (!v || !stage) return;
    var modal = document.getElementById('dvb-ar-modal');
    // Modal kapandıysa uygulama; bir sonraki openModal'da cache'den anında gelir.
    if (!modal || !modal.classList.contains('open')) return;
    // Zaten video modundaysa (setRugVideo başarılı olmuşsa) tekrar set etme.
    if (stage.getAttribute('data-mode') === 'video') return;
    v.muted = true; v.loop = true; v.playsInline = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
    if (v._dvbSrc !== src) { v._dvbSrc = src; v.src = src; try { v.load(); } catch(_e){} }
    v.style.display = '';
    stage.setAttribute('data-mode', 'video');
    stage.removeAttribute('data-empty');
    function tryPlay() {
      try {
        var p = v.play();
        if (p && p.catch) p.catch(function(err) {
          console.warn('[AR] özel ölçü async video autoplay reddedildi:', err && err.message);
          stage.removeAttribute('data-mode');
          v.style.display = 'none';
        });
      } catch(_e) {}
    }
    if (v.readyState >= 2) {
      tryPlay();
    } else {
      v.addEventListener('loadeddata', tryPlay, { once: true });
      v.addEventListener('canplay', tryPlay, { once: true });
      var t = setTimeout(function() {
        if (v.readyState < 2) {
          console.warn('[AR] özel ölçü async video yüklenemedi');
          stage.removeAttribute('data-mode');
          v.style.display = 'none';
        }
      }, 1500);
      v.addEventListener('loadeddata', function(){ clearTimeout(t); }, { once: true });
    }
    console.log('[AR] özel ölçü async video uygulandı:', src);
  }

  function setRugImage() {
    var rug = document.getElementById('dvb-ar-rug');
    var stage = document.getElementById('dvb-ar-rug-stage');
    if (!rug || !stage) return;
    var sels = ['.hdt-product__media-item img','.hdt-slider__slide img','.hdt-main-product__media img','.product-single__photo img','.product__media img','[data-product-media-type="image"] img','.product-featured-media img'];
    var img = null;
    for (var i = 0; i < sels.length; i++) { var el = document.querySelector(sels[i]); if (el && el.src && (el.naturalWidth > 100 || el.complete)) { img = el; break; } }
    if (!img) { var all = document.querySelectorAll('img'); for (var j = 0; j < all.length; j++) { if (all[j].naturalWidth > 300) { img = all[j]; break; } } }
    if (img && img.src) { rug.style.backgroundImage = 'url(' + img.src + ')'; stage.removeAttribute('data-empty'); }
  }
  function bindRugTilt() {
    var stage = document.getElementById('dvb-ar-rug-stage');
    var rug = document.getElementById('dvb-ar-rug');
    if (!stage || !rug || stage._tiltBound) return;
    stage._tiltBound = true;
    stage.addEventListener('mousemove', function(e) {
      var r = stage.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width - 0.5;
      var py = (e.clientY - r.top) / r.height - 0.5;
      rug.classList.add('tilting');
      rug.style.transform = 'translateY(' + (py * -10) + 'px) rotateX(' + (15 + py * 8) + 'deg) rotateY(' + (px * 30) + 'deg)';
    });
    stage.addEventListener('mouseleave', function() { rug.classList.remove('tilting'); rug.style.transform = ''; });
  }
  // ar55: modal video'sunu durdur (modal kapanınca + AR launch öncesi).
  // Telefon ses/işlemci tüketmesin diye pause + currentTime=0.
  function stopRugVideo() {
    var v = document.getElementById('dvb-ar-video');
    if (!v) return;
    try { v.pause(); v.currentTime = 0; } catch(_e){}
  }
  function closeModal() {
    var m = document.getElementById('dvb-ar-modal');
    if (m) m.classList.remove('open');
    stopRugVideo();
    // ar55.10: Pipeline kilidini serbest bırak — modal kapanınca yeni tıklama geçerli.
    _arPipelineLock = false;
  }
  // Global expose — renderViewer/doLaunch içinden çağrılabilsin diye.
  try { window.__dvbStopRugVideo__ = stopRugVideo; } catch(_e){}

  function setBody(html) {
    if (typeof stopCardRotation === 'function') stopCardRotation();
    var b = document.getElementById('dvb-ar-body');
    if (b) b.innerHTML = html;
  }

  // ───── Loading kart sistemi (AR beklerken bilgi göster) ─────
  var _cardData = null;
  var _cardCurrentIdx = 0;
  var _cardRotateTimer = null;
  var CARD_ROTATE_MS = 4000;

  function readAiCache() {
    var pid = (window.productData && window.productData.id) || null;
    if (!pid) return null;
    try {
      var cached = localStorage.getItem('ai_smart_v12_psychology_' + pid);
      if (!cached) return null;
      var parsed = JSON.parse(cached);
      return (parsed && parsed.content) ? parsed.content : null;
    } catch(e) { return null; }
  }

  function fmtTL(n) {
    try { return n.toLocaleString('tr-TR', {minimumFractionDigits:2,maximumFractionDigits:2}) + ' TL'; }
    catch(e) { return n.toFixed(2) + ' TL'; }
  }

  function buildLoadingCards() {
    var pd = window.productData || {};
    var ai = readAiCache();
    var price = (pd.selectedVariant && pd.selectedVariant.price) || pd.price || 0;
    var compare = (pd.selectedVariant && pd.selectedVariant.comparePrice) || pd.comparePrice || price;
    var hasDiscount = pd.hasDiscount && pd.discountPercent > 0;
    var totalInv = pd.totalInventory;
    var lowStock = totalInv > 0 && totalInv < 10;
    var installment6 = price > 0 ? (price / 6) : 0;
    var cards = [];

    if (ai && ai.salesPitch) {
      cards.push({
        title: 'Bu halıyı özel yapan ne?',
        body: '<div class="dvb-ar-card__body">' + ai.salesPitch + '</div>'
      });
    }

    var rows = [];
    if (pd.selectedVariant && pd.selectedVariant.title) {
      var sm = String(pd.selectedVariant.title).match(/(\d+)\s*[xX\u00d7]\s*(\d+)/);
      if (sm) rows.push(['Boyut', sm[1] + ' × ' + sm[2] + ' cm']);
    }
    if (pd.metafields) {
      if (pd.metafields.material) rows.push(['Malzeme', pd.metafields.material]);
      if (pd.metafields.pile) rows.push(['Hav yüksekliği', pd.metafields.pile]);
      if (pd.metafields.origin) rows.push(['Üretim', pd.metafields.origin]);
    }
    if (rows.length > 0) {
      var tHtml = '<div class="dvb-ar-card__feat">';
      for (var i = 0; i < Math.min(4, rows.length); i++) {
        tHtml += '<span class="dvb-ar-card__feat-key">' + rows[i][0] + '</span><span class="dvb-ar-card__feat-val">' + rows[i][1] + '</span>';
      }
      tHtml += '</div>';
      cards.push({ title: 'Teknik özellikler', body: tHtml });
    }

    if (price > 0) {
      var pHtml = '<span class="dvb-ar-card__price-main">' + fmtTL(price) + '</span>';
      pHtml += '<span class="dvb-ar-card__price-sub">veya 6 × <strong>' + fmtTL(installment6) + '</strong> (vade farksız)</span>';
      if (hasDiscount) {
        pHtml += '<div><span class="dvb-ar-card__discount">%' + pd.discountPercent + ' indirim · ' + fmtTL(parseFloat(pd.savings)) + ' tasarruf</span></div>';
      }
      cards.push({ title: 'Ödeme avantajı', body: pHtml });
    }

    var perks =
      '<div class="dvb-ar-card__perks">' +
        '<div class="dvb-ar-card__perk"><svg class="dvb-ar-card__perk-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg><span><strong>Ücretsiz kargo</strong> · 2-3 iş günü teslim</span></div>' +
        '<div class="dvb-ar-card__perk"><svg class="dvb-ar-card__perk-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg><span><strong>14 gün koşulsuz iade</strong> · Risk yok</span></div>' +
        '<div class="dvb-ar-card__perk"><svg class="dvb-ar-card__perk-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg><span><strong>SSL güvenli ödeme</strong> · Tüm kartlar geçerli</span></div>' +
      '</div>';
    cards.push({ title: 'Size özel avantajlar', body: perks });

    if (lowStock) {
      cards.push({
        title: 'Stok durumu',
        body: '<div class="dvb-ar-card__body">Stoklarımızda <span class="dvb-ar-card__stock">son ' + totalInv + ' adet</span> kaldı. Ürünü kaçırmamak için kararınızı erkene almak isteyebilirsiniz.</div>'
      });
    }

    _cardData = cards;
    _cardCurrentIdx = 0;

    if (cards.length === 0) return '';

    var html = '<div class="dvb-ar-cards"><div class="dvb-ar-card" id="dvb-ar-card-active"><div class="dvb-ar-card__title">' + cards[0].title + '</div>' + cards[0].body + '</div><div class="dvb-ar-dots" id="dvb-ar-dots">';
    for (var d = 0; d < cards.length; d++) {
      html += '<button type="button" class="dvb-ar-dot' + (d === 0 ? ' active' : '') + '" data-idx="' + d + '" aria-label="Kart ' + (d+1) + '"></button>';
    }
    html += '</div></div>';
    return html;
  }

  function goToCard(idx) {
    var cardEl = document.getElementById('dvb-ar-card-active');
    if (!cardEl || !_cardData || idx === _cardCurrentIdx) {
      if (!cardEl) stopCardRotation();
      return;
    }
    cardEl.classList.add('fade-out');
    setTimeout(function() {
      var c = _cardData[idx];
      if (!c) return;
      var el = document.getElementById('dvb-ar-card-active');
      if (!el) { stopCardRotation(); return; }
      el.innerHTML = '<div class="dvb-ar-card__title">' + c.title + '</div>' + c.body;
      el.classList.remove('fade-out');
      _cardCurrentIdx = idx;
      var dots = document.querySelectorAll('.dvb-ar-dot');
      for (var d = 0; d < dots.length; d++) {
        if (d === idx) dots[d].classList.add('active');
        else dots[d].classList.remove('active');
      }
    }, 350);
  }

  function startCardRotation() {
    stopCardRotation();
    if (!_cardData || _cardData.length <= 1) return;
    var dotsEl = document.getElementById('dvb-ar-dots');
    if (dotsEl && !dotsEl._dvbBound) {
      dotsEl._dvbBound = true;
      dotsEl.addEventListener('click', function(e) {
        var dot = e.target.closest && e.target.closest('.dvb-ar-dot');
        if (!dot) return;
        var idx = parseInt(dot.getAttribute('data-idx'), 10);
        if (isNaN(idx)) return;
        stopCardRotation();
        goToCard(idx);
        setTimeout(startCardRotation, 1500);
      });
    }
    _cardRotateTimer = setInterval(function() {
      if (!_cardData) { stopCardRotation(); return; }
      var nextIdx = (_cardCurrentIdx + 1) % _cardData.length;
      goToCard(nextIdx);
    }, CARD_ROTATE_MS);
  }

  function stopCardRotation() {
    if (_cardRotateTimer) { clearInterval(_cardRotateTimer); _cardRotateTimer = null; }
  }

  function setLoading(text) {
    var statusEl = document.getElementById('dvb-ar-status-mini');
    if (statusEl) {
      statusEl.innerHTML = text;
      return;
    }
    setBody(
      buildLoadingCards() +
      '<div class="dvb-ar-loading-mini">' +
        '<div class="dvb-ar-spin-mini"></div>' +
        '<span id="dvb-ar-status-mini">' + text + '</span>' +
      '</div>'
    );
    startCardRotation();
  }

  function setError(msg) {
    setBody('<div class="dvb-ar-error"><strong>Üzgünüz, bir aksaklık oldu.</strong><br>' + msg + '</div>');
  }

  // ═══════════════════ HASH ═══════════════════
  async function sha256Hex(str) {
    var enc = new TextEncoder().encode(str);
    var buf = await crypto.subtle.digest('SHA-256', enc);
    var hex = '';
    var bytes = new Uint8Array(buf);
    for (var i = 0; i < bytes.length; i++) hex += bytes[i].toString(16).padStart(2, '0');
    return hex;
  }

  // ═══════════════════ MEVCUT STATE OKU ═══════════════════
  function readDesignState() {
    var w = parseFloat((document.getElementById('ozel-olcu-width') || {}).value) || 0;
    var h = parseFloat((document.getElementById('ozel-olcu-length') || {}).value) || 0;
    var shape = ((document.getElementById('ozel-olcu-shape') || {}).value || 'dikdortgen').toLowerCase();
    // Edge type
    var edge = 'biye';
    var checkedEdge = document.querySelector('input[name="ozel-olcu-edge"]:checked');
    if (checkedEdge) edge = (checkedEdge.value || 'biye').toLowerCase();
    // qualityCode + patternKey
    var cfg = window.__OZEL_OLCU_CONFIG__ || {};
    var qc = (cfg.qualityCode || '').toString().toLowerCase();
    var patternKey = '';
    try {
      var bp = document.getElementById('banner-product');
      patternKey = (bp && bp.dataset.productHandle) || '';
    } catch (e) {}
    // Amorf konturu (deterministic). Önce contour (gerçek bezier sampled XY 0-1),
    // yedek olarak radii (polar). Contour daha doğru çünkü editor canvas'taki
    // gerçek dış çizgiyi temsil eder; eski radii eşit-açı interpolasyonu karmaşık
    // amorf şekilleri oval'e yakınsatıyordu.
    var amorfRadii = null, amorfContour = null;
    if (shape === 'amorf' && window.__OzelOlcuAmorf && window.__OzelOlcuAmorf.getShape) {
      try {
        var sh = window.__OzelOlcuAmorf.getShape();
        if (sh) {
          if (sh.contour && sh.contour.length >= 8) {
            amorfContour = sh.contour.map(function (p) {
              return [Math.round(p[0] * 10000) / 10000, Math.round(p[1] * 10000) / 10000];
            });
          }
          if (sh.radii && sh.radii.length) {
            amorfRadii = Array.from(sh.radii).map(function (r) { return Math.round(r * 1000) / 1000; });
          }
        }
      } catch (e) {}
    }
    return {
      widthCm: w, lengthCm: h, shape: shape, edge: edge,
      qualityCode: qc, patternKey: patternKey,
      amorfRadii: amorfRadii, amorfContour: amorfContour
    };
  }

  // ═══════════════════ TEXTURE ═══════════════════
  // Mevcut giydirme canvas'ını yüksek çözünürlüklü PNG blob olarak al.
  // ASYNC: amorf için window.__amorfLastPreviewDataUrl'i image'a yükleyip
  // gizli canvas'a basar. Diğer şekillerde dikdörtgenle aynı senkron kaynak.
  // DV_AR_TRANSPARENT_FRINGE_GROUNDED_20260807
  // The tolerance is evidence-derived from the affected 3000x4274 Prime 8306 source:
  // the foreground bbox stays stable through delta 24 while the connected studio
  // background is removed. Only border-connected light pixels are cleared; this is
  // deliberately not a global white threshold, so internal whites and fringe fibres remain.
  function isolateEdgeConnectedStudioBackgroundPixels(rgba, width, height) {
    const tolerance = 24;
    const pixelCount = width * height;
    if (!rgba || rgba.length !== pixelCount * 4 || width < 2 || height < 2) {
      return { changed: false, reason: 'invalid-input' };
    }
  
    for (let p = 3; p < rgba.length; p += 4) {
      if (rgba[p] < 250) return { changed: false, reason: 'existing-alpha' };
    }
  
    const red = [];
    const green = [];
    const blue = [];
    function sample(pixelIndex) {
      const offset = pixelIndex * 4;
      red.push(rgba[offset]);
      green.push(rgba[offset + 1]);
      blue.push(rgba[offset + 2]);
    }
    for (let x = 0; x < width; x += 1) {
      sample(x);
      sample((height - 1) * width + x);
    }
    for (let y = 1; y < height - 1; y += 1) {
      sample(y * width);
      sample(y * width + width - 1);
    }
    function median(values) {
      values.sort((a, b) => a - b);
      return values[Math.floor(values.length / 2)];
    }
    const background = [median(red), median(green), median(blue)];
    const borderDistances = new Array(red.length);
    for (let i = 0; i < red.length; i += 1) {
      borderDistances[i] = Math.max(
        Math.abs(red[i] - background[0]),
        Math.abs(green[i] - background[1]),
        Math.abs(blue[i] - background[2])
      );
    }
    borderDistances.sort((a, b) => a - b);
    const borderP95 = borderDistances[Math.floor((borderDistances.length - 1) * 0.95)];
    const backgroundMin = Math.min(background[0], background[1], background[2]);
    const backgroundMax = Math.max(background[0], background[1], background[2]);
    if (
      backgroundMin < 255 - tolerance ||
      backgroundMax - backgroundMin > tolerance ||
      borderP95 > tolerance
    ) {
      return { changed: false, reason: 'non-uniform-light-border', background, borderP95 };
    }
  
    function isCandidate(pixelIndex) {
      const offset = pixelIndex * 4;
      return Math.max(
        Math.abs(rgba[offset] - background[0]),
        Math.abs(rgba[offset + 1] - background[1]),
        Math.abs(rgba[offset + 2] - background[2])
      ) <= tolerance;
    }
  
    let candidateCount = 0;
    for (let pixelIndex = 0; pixelIndex < pixelCount; pixelIndex += 1) {
      if (isCandidate(pixelIndex)) candidateCount += 1;
    }
    if (!candidateCount) {
      return { changed: false, reason: 'no-background-candidates', background, borderP95 };
    }
  
    const queue = new Int32Array(candidateCount);
    let head = 0;
    let tail = 0;
    function push(pixelIndex) {
      const alphaOffset = pixelIndex * 4 + 3;
      if (rgba[alphaOffset] === 0 || !isCandidate(pixelIndex)) return;
      rgba[alphaOffset] = 0;
      queue[tail] = pixelIndex;
      tail += 1;
    }
    for (let x = 0; x < width; x += 1) {
      push(x);
      push((height - 1) * width + x);
    }
    for (let y = 1; y < height - 1; y += 1) {
      push(y * width);
      push(y * width + width - 1);
    }
    while (head < tail) {
      const pixelIndex = queue[head];
      head += 1;
      const x = pixelIndex % width;
      const y = Math.floor(pixelIndex / width);
      if (x > 0) push(pixelIndex - 1);
      if (x + 1 < width) push(pixelIndex + 1);
      if (y > 0) push(pixelIndex - width);
      if (y + 1 < height) push(pixelIndex + width);
    }
  
    if (!tail || tail === pixelCount) {
      for (let p = 3; p < rgba.length; p += 4) rgba[p] = 255;
      return { changed: false, reason: 'unsafe-empty-foreground', background, borderP95 };
    }
  
    let minX = width;
    let minY = height;
    let maxX = -1;
    let maxY = -1;
    for (let pixelIndex = 0; pixelIndex < pixelCount; pixelIndex += 1) {
      if (rgba[pixelIndex * 4 + 3] === 0) continue;
      const x = pixelIndex % width;
      const y = Math.floor(pixelIndex / width);
      if (x < minX) minX = x;
      if (x > maxX) maxX = x;
      if (y < minY) minY = y;
      if (y > maxY) maxY = y;
    }
    return {
      changed: true,
      reason: 'edge-connected-light-background',
      background,
      borderP95,
      tolerance,
      removedPixels: tail,
      removedRatio: tail / pixelCount,
      foregroundBBox: { minX, minY, maxX, maxY },
    };
  }

  function prepareArStudioTextureCanvas(srcCanvas) {
    try {
      var ctx = srcCanvas.getContext('2d', { willReadFrequently: true });
      var imageData = ctx.getImageData(0, 0, srcCanvas.width, srcCanvas.height);
      var result = isolateEdgeConnectedStudioBackgroundPixels(
        imageData.data, srcCanvas.width, srcCanvas.height
      );
      if (result.changed) ctx.putImageData(imageData, 0, 0);
      window.__DVB_AR_LAST_ALPHA_MASK__ = result;
      console.log('[DVB-AR] studio background mask:', result);
    } catch (error) {
      console.warn('[DVB-AR] studio background mask skipped:', error && error.message);
    }
    return srcCanvas;
  }
  async function pickSourceCanvas(state) {
    // ar36: ozel-olcu-plus.js'de isAmorf() → oval ve daire de amorf canvas kullanıyor.
    // Site: oval/daire seçilince amorf editör aktifleşir, noktalarla kullanıcı şekli belirler.
    // Bu yüzden AR da oval/daire için amorf branch kullanmalı; preview-canvas YOKTUR.
    var usesAmorfCanvas = (state.shape === 'amorf' || state.shape === 'oval' ||
                           state.shape === 'daire' || state.shape === 'circle');
    if (usesAmorfCanvas) {
      // Gerçek "giydirilmiş" görsel ozel-olcu-plus.js → renderPreview() sonucu olarak
      // window.__amorfLastPreviewDataUrl'e PNG dataURL olarak kaydediliyor.
      // Editor canvas'ı (#ozel-olcu-amorf-canvas) ÜZERİNDE turuncu biye guide,
      // ölçü etiketleri ve dashed safe-area çizgileri var — bunlar AR halısına
      // sızmasın diye editor canvas'ını DEĞİL bu giydirme dataURL'ini kullanıyoruz.
      // ar46: AR-only saçak texture (dilated ring) öncelikli, yoksa normal preview
      var dataUrl = window.__amorfARTextureDataUrl || window.__amorfLastPreviewDataUrl;
      if (dataUrl && typeof dataUrl === 'string' && dataUrl.indexOf('data:image') === 0) {
        try {
          var img = await new Promise(function (resolve, reject) {
            var im = new Image();
            im.onload = function () { resolve(im); };
            im.onerror = function (e) { reject(new Error('amorf preview image load fail')); };
            im.src = dataUrl;
          });
          var w = img.naturalWidth || img.width || 800;
          var h = img.naturalHeight || img.height || 800;
          var cv = document.createElement('canvas');
          cv.width = w; cv.height = h;
          var cctx = cv.getContext('2d', { willReadFrequently: true });
          cctx.drawImage(img, 0, 0, w, h);
          // ŞIRıNGA: renderPreview halı etrafına 14px blurred drop-shadow ekliyor
          // (rgba(0,0,0,0.10), alpha~25). Bu halka silhouette trace'e ve alpha-bbox'a
          // sızıp mesh'i halıdan büyük yapıyor �� AR'da gri halo + biye sıkışması +
          // aspect distortion. Burada alpha < 96 olan tüm pikselleri tamamen
          // transparent yapıp halo'yu siliyoruz; halı + biye'nin asıl 96+ alpha'lı
          // gövdesi ve antialiased iç kenar dokunulmaz.
          try {
            var imgData = cctx.getImageData(0, 0, w, h);
            var d = imgData.data;
            var stripped = 0;
            for (var p = 3; p < d.length; p += 4) {
              if (d[p] < 96) {
                d[p] = 0;
                d[p - 1] = 0; d[p - 2] = 0; d[p - 3] = 0;
                stripped++;
              }
            }
            cctx.putImageData(imgData, 0, 0);
            // ar49: tanı log — kaynak rez + dvbInfer Shopify CDN URL'si (varsa)
            var dvbSrc = '';
            try { dvbSrc = (window.__dvbInferLastSrcUrl__ || (window.dvbInfer && window.dvbInfer.lastSrcUrl) || ''); } catch(_e){}
            console.log('[AR] amorf texture: __amorfLastPreviewDataUrl', {
              w: w, h: h, shadowStrippedPx: stripped,
              dvbInferSrc: dvbSrc || '(theme.liquid dvbInfer URL exposed degil)',
              dataUrlSource: (window.__amorfARTextureDataUrl ? 'AR-only (sacakli)' : 'preview')
            });
          } catch (sErr) {
            console.warn('[AR] shadow strip atlandı:', sErr);
          }
          return cv;
        } catch (e) {
          console.warn('[AR] __amorfLastPreviewDataUrl yüklenemedi, fallback editor canvas', e);
        }
      }
      // Fallback (editor canvas — overlay'li, ideal değil ama hiç yoktan iyi)
      var amorfCanvases = ['ozel-olcu-amorf-canvas', 'amorf-preview-canvas'];
      for (var i = 0; i < amorfCanvases.length; i++) {
        var c = document.getElementById(amorfCanvases[i]);
        if (c && c.width > 16) {
          console.warn('[AR] amorf texture FALLBACK editor canvas:', amorfCanvases[i]);
          return c;
        }
      }
      return null;
    }
    // Dikdörtgen / oval / daire: değişiklik YOK — preview canvas senkron.
    var pc = document.getElementById('ozel-olcu-preview-canvas');
    if (pc && pc.width > 16) return pc;
    return null;
  }

  function fitCanvasToMax(srcCanvas, maxSide) {
    var longest = Math.max(srcCanvas.width, srcCanvas.height);
    if (!(longest > maxSide)) return srcCanvas;
    var scale = maxSide / longest;
    var dst = document.createElement('canvas');
    dst.width = Math.max(1, Math.round(srcCanvas.width * scale));
    dst.height = Math.max(1, Math.round(srcCanvas.height * scale));
    var ctx = dst.getContext('2d');
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(srcCanvas, 0, 0, dst.width, dst.height);
    return dst;
  }
  function upscaleCanvas(srcCanvas, targetMin) {
    var sw = srcCanvas.width, sh = srcCanvas.height;
    var s = Math.max(targetMin / Math.max(sw, sh), 1);
    if (s <= 1.05) return srcCanvas;
    var dst = document.createElement('canvas');
    dst.width = Math.round(sw * s);
    dst.height = Math.round(sh * s);
    var dctx = dst.getContext('2d');
    dctx.imageSmoothingEnabled = true;
    dctx.imageSmoothingQuality = 'high';
    dctx.drawImage(srcCanvas, 0, 0, dst.width, dst.height);
    return dst;
  }

  // ═══════════════════ THREE.JS LAZY LOAD ═══════════════════
  // ar35: CDN fallback chain — esm.sh Türkiye'de zaman zaman bloke olabiliyor.
  // jsdelivr +esm: bare import'ları bundle ediyor (rollup), Türkiye'de erişilebilir.
  async function loadThree() {
    if (threeMods) return threeMods;
    var V = THREE_VER;
    var sources = [
      {
        name: 'esm.sh',
        three: 'https://esm.sh/three@' + V,
        gltf:  'https://esm.sh/three@' + V + '/examples/jsm/exporters/GLTFExporter.js',
        usdz:  'https://esm.sh/three@' + V + '/examples/jsm/exporters/USDZExporter.js',
      },
      {
        name: 'jsdelivr+esm',
        three: 'https://cdn.jsdelivr.net/npm/three@' + V + '/+esm',
        gltf:  'https://cdn.jsdelivr.net/npm/three@' + V + '/examples/jsm/exporters/GLTFExporter.js/+esm',
        usdz:  'https://cdn.jsdelivr.net/npm/three@' + V + '/examples/jsm/exporters/USDZExporter.js/+esm',
      },
    ];
    var lastErr = null;
    for (var i = 0; i < sources.length; i++) {
      var src = sources[i];
      try {
        console.log('[AR] loadThree trying:', src.name);
        var THREE = await import(/* @vite-ignore */ src.three);
        var GLTFExporter = (await import(/* @vite-ignore */ src.gltf)).GLTFExporter;
        var USDZExporter = (await import(/* @vite-ignore */ src.usdz)).USDZExporter;
        if (!THREE || !GLTFExporter || !USDZExporter) {
          throw new Error('CDN modülleri eksik: ' + src.name);
        }
        console.log('[AR] loadThree success via:', src.name);
        threeMods = { THREE: THREE, GLTFExporter: GLTFExporter, USDZExporter: USDZExporter };
        return threeMods;
      } catch (e) {
        console.warn('[AR] loadThree failed:', src.name, e && (e.message || e));
        lastErr = e;
      }
    }
    throw new Error('3D motoru CDN\'den yüklenemedi: ' + (lastErr && lastErr.message || 'unknown'));
  }

  async function loadModelViewer() {
    if (modelViewerReady) return;
    if (customElements.get('model-viewer')) { modelViewerReady = true; return; }
    var s = document.createElement('script');
    s.type = 'module';
    s.src = 'https://cdn.jsdelivr.net/npm/@google/model-viewer@3.5.0/dist/model-viewer.min.js';
    document.head.appendChild(s);
    await new Promise(function (resolve) {
      var t0 = Date.now();
      (function check() {
        if (customElements.get('model-viewer')) { modelViewerReady = true; resolve(); return; }
        if (Date.now() - t0 > 8000) { resolve(); return; }
        setTimeout(check, 80);
      })();
    });
  }

  async function loadQR() {
    if (qrLib) return qrLib;
    qrLib = await import(/* @vite-ignore */ 'https://esm.sh/qrcode@1.5.3');
    return qrLib;
  }

  // ═══════════════════ ALPHA SILHOUETTE TRACE ═══════════════════
  // Texture canvas'taki halının dış sınırını piksel-level trace eder.
  // Moore-Neighbor 8-bağlantılı boundary tracing. Çıktı: low-res mask koord.
  // sisteminde kontur noktaları (sonra metric mesh coord'larına çevrilir).
  // Bu yaklaşım kullanıcının editör kontrol noktalarına bağımlılığı kaldırır;
  // mesh sınırı, render edilmiş halının gerçek silhouette'ine birebir oturur.
  function traceAlphaSilhouette(canvas, alphaThreshold) {
    // Threshold 96: pickSourceCanvas amorf branch'ında drop-shadow zaten alpha=0'a
    // çekildi. Burada da 96 kullanmak measureAlphaBBox ile UV uyumunu garantiler:
    // mesh-bbox ≡ alpha-bbox → UV mesh kenarına birebir oturur, biye sıkışmaz.
    var thr = alphaThreshold || 96;
    var srcW = canvas.width, srcH = canvas.height;
    // ar18: 256→512 → karmaşık (non-convex, sivri çıkıntılı) amorflarda mesh
    // halı sınırına 1-3px hassasiyet (eski 4-8px). User WhatsApp 13.14.51'de
    // mesh > halı halo problemi → düşük res silhouette = trace yanlış konturda
    // gezinip halı dışına taşma. 512 ile 200x150cm halı work canvas 358×512,
    // 1.4mm/pixel hassasiyet — antialiased kenar bile 1px sapma.
    var maxDim = 512;
    var scale = Math.min(maxDim / srcW, maxDim / srcH, 1);
    var w = Math.max(8, Math.round(srcW * scale));
    var h = Math.max(8, Math.round(srcH * scale));
    var work = document.createElement('canvas');
    work.width = w; work.height = h;
    var wctx = work.getContext('2d', { willReadFrequently: true });
    wctx.drawImage(canvas, 0, 0, w, h);
    var data = wctx.getImageData(0, 0, w, h).data;

    // Binary mask
    var mask = new Uint8Array(w * h);
    var minX = w, minY = h, maxX = -1, maxY = -1;
    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        if (data[(y * w + x) * 4 + 3] > thr) {
          mask[y * w + x] = 1;
          if (x < minX) minX = x;
          if (y < minY) minY = y;
          if (x > maxX) maxX = x;
          if (y > maxY) maxY = y;
        }
      }
    }
    if (maxX < 0) return null;

    // İlk boundary piksel: sol-üstten tarayarak ilk dolu piksel
    var startX = -1, startY = -1;
    for (var sy = 0; sy < h && startX < 0; sy++) {
      for (var sx = 0; sx < w; sx++) {
        if (mask[sy * w + sx]) { startX = sx; startY = sy; break; }
      }
    }
    if (startX < 0) return null;

    // 8 yön: 0=E, 1=SE, 2=S, 3=SW, 4=W, 5=NW, 6=N, 7=NE
    var DX = [1, 1, 0, -1, -1, -1, 0, 1];
    var DY = [0, 1, 1,  1,  0, -1, -1, -1];
    var contour = [];
    var cx = startX, cy = startY;
    var prevDir = 6; // baktığımız önceki yön: yukarıdan geldik (üst boş)
    contour.push({ x: cx, y: cy });

    var maxIter = w * h;
    for (var it = 0; it < maxIter; it++) {
      // Önceki yönün karşıt + 1 (Moore neighbor backtrack)
      var startDir = (prevDir + 6) % 8;
      var found = false;
      for (var i = 0; i < 8; i++) {
        var d = (startDir + i) % 8;
        var nx = cx + DX[d], ny = cy + DY[d];
        if (nx >= 0 && nx < w && ny >= 0 && ny < h && mask[ny * w + nx]) {
          cx = nx; cy = ny; prevDir = d;
          contour.push({ x: cx, y: cy });
          found = true;
          break;
        }
      }
      if (!found) break;
      if (cx === startX && cy === startY && contour.length > 8) break;
    }

    // ar18: 128→192 — 512 work canvas'ta non-convex amorflar 800-1200 nokta üretir
    // → step=4-6 → ~200 nokta. Karmaşık çıkıntılı amorflarda kıvrım detayı korunur.
    var target = 192;
    var step = Math.max(1, Math.floor(contour.length / target));
    var simp = [];
    for (var k = 0; k < contour.length; k += step) simp.push(contour[k]);
    if (simp.length < 16) simp = contour.slice();

    // Bbox + work ç��zünürlüğüne göre normalize 0-1 dön
    var bw = (maxX - minX) || 1;
    var bh = (maxY - minY) || 1;
    var normalized = simp.map(function (p) {
      return { nx: (p.x - minX) / bw, ny: (p.y - minY) / bh };
    });
    return {
      points: normalized,
      // Aspect ratio bilgisi: halının texture içindeki gerçek en/boy oranı
      aspect: bw / bh
    };
  }

  // ═══════════════════ AMORF MESH FIX (v2-amorf-fix) ═══════════════════
  // Mevcut traceAlphaSilhouette + buildShape(amorf) + UV mapping + preprocessForUsdz
  // pipeline'ı 5-10cm gri/krem halo üretiyordu (WhatsApp 2026-04-30 görselleri):
  //   1) traceAlphaSilhouette 512 work canvas'a downscale → 4× resolution loss → mesh
  //      kontur halı kenarına 4-8 piksel bias.
  //   2) measureAlphaBBox subsample step=4 + padPx=-2 → texture alpha bbox mesh
  //      AABB'sinden 4-8 piksel kayık → UV mismatch.
  //   3) preprocessForUsdz alpha<220 pikselleri carpet ortalama gri'ye dolduruyor →
  //      mesh kenarındaki UV mismatch alanı opaque gri olarak görünür.
  //
  // Bu blok amorf için PARALEL pipeline sunar:
  //   • Full-resolution alpha mask (downscale yok)
  //   • Largest-component flood-fill (drop-shadow halkası dışlanır)
  //   • Moore-Neighbor 8-bağlantılı boundary tracing (pixel-perfect)
  //   • Chaikin smoothing (2 iter) + Douglas-Peucker simplify (eps=1.25 px)
  //   • Texture crop'u alpha bbox'a + hard alpha cutoff (carpet color sadece alpha=0
  //     pikseller için → bilinear sampling kenarda dark fringe yapmaz)
  //   • Mesh shape ≡ alpha contour ≡ cropped texture bounds → UV birebir, mismatch yok
  //   • preprocessForUsdz amorf için BYPASS edilir.

  function _amorfLargestComponent(alpha, w, h, threshold) {
    var visited = new Uint8Array(w * h);
    var bestMask = null, bestSize = 0, bestBBox = null;
    var stack = new Int32Array(w * h * 2);
    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        var i0 = y * w + x;
        if (visited[i0] || alpha[i0] < threshold) continue;
        var mask = new Uint8Array(w * h);
        var sp = 0;
        stack[sp++] = x; stack[sp++] = y;
        var size = 0, minX = x, maxX = x, minY = y, maxY = y;
        while (sp > 0) {
          var cy = stack[--sp], cx = stack[--sp];
          var ci = cy * w + cx;
          if (visited[ci] || alpha[ci] < threshold) continue;
          visited[ci] = 1; mask[ci] = 1; size++;
          if (cx < minX) minX = cx;
          if (cx > maxX) maxX = cx;
          if (cy < minY) minY = cy;
          if (cy > maxY) maxY = cy;
          if (cx > 0)     { stack[sp++] = cx - 1; stack[sp++] = cy; }
          if (cx < w - 1) { stack[sp++] = cx + 1; stack[sp++] = cy; }
          if (cy > 0)     { stack[sp++] = cx;     stack[sp++] = cy - 1; }
          if (cy < h - 1) { stack[sp++] = cx;     stack[sp++] = cy + 1; }
        }
        if (size > bestSize) {
          bestSize = size; bestMask = mask;
          bestBBox = { x: minX, y: minY, w: maxX - minX + 1, h: maxY - minY + 1 };
        }
      }
    }
    return { mask: bestMask, size: bestSize, bbox: bestBBox };
  }

  var _AMORF_DIRS = [
    [ 1, 0], [ 1, 1], [ 0, 1], [-1, 1],
    [-1, 0], [-1,-1], [ 0,-1], [ 1,-1]
  ];

  function _amorfMooreTrace(mask, w, h, bbox) {
    var start = null;
    outer:
    for (var y = bbox.y; y < bbox.y + bbox.h; y++) {
      for (var x = bbox.x; x < bbox.x + bbox.w; x++) {
        if (mask[y * w + x]) { start = { x: x, y: y }; break outer; }
      }
    }
    if (!start) return [];
    var contour = [start];
    var cur = start;
    var backtrack = 4;
    var firstDirOut = -1;
    var maxIter = w * h;
    for (var it = 0; it < maxIter; it++) {
      var foundIdx = -1, nx = 0, ny = 0;
      for (var i = 0; i < 8; i++) {
        var dIdx = (backtrack + 1 + i) & 7;
        var tx = cur.x + _AMORF_DIRS[dIdx][0];
        var ty = cur.y + _AMORF_DIRS[dIdx][1];
        if (tx < 0 || ty < 0 || tx >= w || ty >= h) continue;
        if (mask[ty * w + tx]) { foundIdx = dIdx; nx = tx; ny = ty; break; }
      }
      if (foundIdx < 0) break;
      if (cur.x === start.x && cur.y === start.y && firstDirOut < 0) {
        firstDirOut = foundIdx;
      }
      backtrack = (foundIdx + 4) & 7;
      cur = { x: nx, y: ny };
      if (cur.x === start.x && cur.y === start.y) {
        var peekDir = -1;
        for (var k = 0; k < 8; k++) {
          var dIdx2 = (backtrack + 1 + k) & 7;
          var tx2 = cur.x + _AMORF_DIRS[dIdx2][0];
          var ty2 = cur.y + _AMORF_DIRS[dIdx2][1];
          if (tx2 < 0 || ty2 < 0 || tx2 >= w || ty2 >= h) continue;
          if (mask[ty2 * w + tx2]) { peekDir = dIdx2; break; }
        }
        if (peekDir === firstDirOut) return contour;
      }
      contour.push(cur);
    }
    return contour;
  }

  function _amorfChaikinSmooth(points, iterations) {
    var pts = points;
    for (var it = 0; it < iterations; it++) {
      var n = pts.length;
      var out = new Array(n * 2);
      for (var i = 0; i < n; i++) {
        var p = pts[i], q = pts[(i + 1) % n];
        out[i * 2]     = { x: 0.75 * p.x + 0.25 * q.x, y: 0.75 * p.y + 0.25 * q.y };
        out[i * 2 + 1] = { x: 0.25 * p.x + 0.75 * q.x, y: 0.25 * p.y + 0.75 * q.y };
      }
      pts = out;
    }
    return pts;
  }

  function _amorfPerpDistSq(p, a, b) {
    var dx = b.x - a.x, dy = b.y - a.y;
    var len2 = dx * dx + dy * dy;
    if (len2 === 0) {
      var ex0 = p.x - a.x, ey0 = p.y - a.y;
      return ex0 * ex0 + ey0 * ey0;
    }
    var t = ((p.x - a.x) * dx + (p.y - a.y) * dy) / len2;
    if (t < 0) t = 0; else if (t > 1) t = 1;
    var cx = a.x + t * dx, cy = a.y + t * dy;
    var ex = p.x - cx, ey = p.y - cy;
    return ex * ex + ey * ey;
  }

  function _amorfDouglasPeucker(points, epsilon) {
    var n = points.length;
    if (n < 3) return points.slice();
    var eps2 = epsilon * epsilon;
    var keep = new Uint8Array(n);
    keep[0] = 1; keep[n - 1] = 1;
    var stack = [[0, n - 1]];
    while (stack.length) {
      var seg = stack.pop();
      var s = seg[0], e = seg[1];
      var maxD = 0, maxI = -1;
      var a = points[s], b = points[e];
      for (var i = s + 1; i < e; i++) {
        var d = _amorfPerpDistSq(points[i], a, b);
        if (d > maxD) { maxD = d; maxI = i; }
      }
      if (maxD > eps2 && maxI > 0) {
        keep[maxI] = 1;
        stack.push([s, maxI]);
        stack.push([maxI, e]);
      }
    }
    var out = [];
    for (var j = 0; j < n; j++) if (keep[j]) out.push(points[j]);
    return out;
  }

  function _amorfCropAndHarden(srcCanvas, bbox, padding, solidThreshold, preserveThreshold) {
    var pad = padding | 0;
    var sx = Math.max(0, bbox.x - pad);
    var sy = Math.max(0, bbox.y - pad);
    var sw = Math.min(srcCanvas.width  - sx, bbox.w + 2 * pad);
    var sh = Math.min(srcCanvas.height - sy, bbox.h + 2 * pad);
    var out = document.createElement('canvas');
    out.width = sw; out.height = sh;
    var octx = out.getContext('2d', { willReadFrequently: true });
    octx.drawImage(srcCanvas, sx, sy, sw, sh, 0, 0, sw, sh);
    var id = octx.getImageData(0, 0, sw, sh);
    var d = id.data;
    // Pass 1: carpet ortalama renk — sadece TAMAMEN OPAK (alpha>=solidThreshold)
    // pikseller. Body + biye solid kısımlarını alır, anti-alias edge'leri dahil
    // etmez. Bu fill rengi mesh dışındaki padding pikselleri için kullanılır
    // (görünmez ama bilinear sampling smooth olsun diye).
    var rSum = 0, gSum = 0, bSum = 0, count = 0;
    for (var i = 0; i < d.length; i += 16) {
      if (d[i + 3] >= solidThreshold) {
        rSum += d[i]; gSum += d[i + 1]; bSum += d[i + 2]; count++;
      }
    }
    var rAvg = count ? Math.round(rSum / count) : 128;
    var gAvg = count ? Math.round(gSum / count) : 128;
    var bAvg = count ? Math.round(bSum / count) : 128;
    // Pass 2: SOLID texture (alpha=255 her piksel) — biye + saçak preservation fix
    // (ar22). Önceki ar21 versiyonu alpha<220 olan tüm pikselleri carpet_avg
    // (= koyu halı gövdesi gri) ile dolduruyordu → biye'nin anti-aliased edge
    // pikselleri (alpha 96-219, RGB=açık gri biye rengi) carpet_avg ile silinip
    // biye AR'da kayboluyordu (WhatsApp 14:55 görseli). Düzeltme:
    //   • alpha >= preserveThreshold (8): RGB AYNEN KORUNUR (body, biye, antialias)
    //   • alpha < preserveThreshold (8):  carpet_avg ile doldurulur (sadece tam
    //     transparent background — pickSourceCanvas alpha<96 strip ile zaten
    //     alpha=0'a düşürülen drop-shadow kalıntısı)
    // Sonuç: biye/bordür/saçak kenar işlemleri sitedeki giydirme ile birebir
    // korunur, USDZ transparent:false PNG round-trip alpha=0 sıfırlama bug'ı da
    // önlenir (alpha=255 her piksel → RGB strip riski yok).
    for (var j = 0; j < d.length; j += 4) {
      if (d[j + 3] < preserveThreshold) {
        d[j] = rAvg; d[j + 1] = gAvg; d[j + 2] = bAvg;
      }
      d[j + 3] = 255;
    }
    octx.putImageData(id, 0, 0);
    return {
      canvas: out, offset: { x: sx, y: sy }, width: sw, height: sh,
      avgRGB: [rAvg, gAvg, bAvg]
    };
  }

  function _amorfSignedArea(pts) {
    var a = 0;
    for (var i = 0, n = pts.length; i < n; i++) {
      var p = pts[i], q = pts[(i + 1) % n];
      a += (q.x - p.x) * (q.y + p.y);
    }
    return a * 0.5;
  }

  // AmorfFix entry point. Returns null on failure.
  function solveAmorfMesh(THREE, srcCanvas, opts) {
    var cfg = {
      alphaThreshold: 64,     // ar37: 32→64. pickSourceCanvas alpha<96 strip sonrası
                              // canvas'ta en düşük alpha ≥96 (biye solid ≥200, AA edge 96-199).
                              // 64 threshold solid biye+AA edge dahil, UV bounds ile aynı
                              // eşik → mesh UV sınırından taşmaz → biye kenarı temiz.
                              // Not: strip sonrası 1-95 arası piksel zaten 0 olduğundan
                              // 32 ile 64 pratikte aynı ama tutarlılık için 64.
      solidThreshold: 220,    // carpet_avg averaging cutoff (only solid pixels)
      preserveThreshold: 8,   // RGB preservation cutoff — alpha>=8 keeps original
                              // RGB so biye/bordür/saçak anti-alias edge'leri
                              // sitedeki giydirme ile birebir korunur
      simplifyEpsilon: 1.5,   // ar25: orta DP (ham kontur jitter'ını temizler)
      smoothIterations: 1,    // ar25: 1 Chaikin iter (2 iter'dan daha az shrink).
                              // Ham kontur Moore trace jitter'ı ~1-2px; smooth=1
                              // ile jitter giderilir, UV fix ile biye tam görünür.
                              // smooth=2 fazla shrink, smooth=0 8500+ vertex+jitter.
      cropPadding: 3,         // bilinear sınır buffer
      minComponentRatio: 0.005
    };
    for (var k in opts) if (Object.prototype.hasOwnProperty.call(opts, k)) cfg[k] = opts[k];

    var W = (srcCanvas && srcCanvas.width)  | 0;
    var H = (srcCanvas && srcCanvas.height) | 0;
    if (!W || !H) { console.error('[AmorfFix] zero dims'); return null; }
    if (!(cfg.widthCm > 0) || !(cfg.heightCm > 0)) {
      console.error('[AmorfFix] invalid dimensions', cfg);
      return null;
    }

    var ctx = srcCanvas.getContext('2d', { willReadFrequently: true });
    var img = ctx.getImageData(0, 0, W, H);
    var alpha = new Uint8Array(W * H);
    var data = img.data;
    for (var i = 0, j = 3; i < alpha.length; i++, j += 4) alpha[i] = data[j];

    var comp = _amorfLargestComponent(alpha, W, H, cfg.alphaThreshold);
    if (!comp.mask || comp.size < W * H * cfg.minComponentRatio) {
      console.error('[AmorfFix] no carpet region', { size: comp.size, area: W * H });
      return null;
    }

    var contourPx = _amorfMooreTrace(comp.mask, W, H, comp.bbox);
    if (contourPx.length < 8) {
      console.error('[AmorfFix] trace too few points', contourPx.length);
      return null;
    }

    contourPx = _amorfChaikinSmooth(contourPx, cfg.smoothIterations);
    contourPx = _amorfDouglasPeucker(contourPx, cfg.simplifyEpsilon);

    var crop = _amorfCropAndHarden(srcCanvas, comp.bbox, cfg.cropPadding, cfg.solidThreshold, cfg.preserveThreshold);

    // Piksel → metre dönüşümü. Halı bbox = kullanıcı w × h (cm). Bbox center
    // mesh origin'i. Y ekseni flip: piksel +y aşağı, mesh +y yukarı.
    var sxM = (cfg.widthCm  * 0.01) / comp.bbox.w;
    var syM = (cfg.heightCm * 0.01) / comp.bbox.h;
    var ccx = comp.bbox.x + comp.bbox.w * 0.5;
    var ccy = comp.bbox.y + comp.bbox.h * 0.5;

    var contourMeters = contourPx.map(function (p) {
      return new THREE.Vector2((p.x - ccx) * sxM, -(p.y - ccy) * syM);
    });
    if (_amorfSignedArea(contourMeters) < 0) contourMeters.reverse();

    var shape = new THREE.Shape(contourMeters);

    console.log('[AmorfFix v2] solved', {
      canvasPx: { w: W, h: H },
      bboxPx: comp.bbox,
      contourPts: contourPx.length,
      croppedPx: { w: crop.width, h: crop.height },
      sizeM: { w: cfg.widthCm * 0.01, h: cfg.heightCm * 0.01 },
      avgRGB: crop.avgRGB
    });

    return {
      shape: shape,
      contourMeters: contourMeters,
      croppedCanvas: crop.canvas,
      bboxPx: comp.bbox,
      sizeMeters: { w: cfg.widthCm * 0.01, h: cfg.heightCm * 0.01 },
      // ar25 UV fix: crop koordinatları UV hesabı için (bkz. remapAmorfExtrudeUVs)
      cropOffset: { x: crop.offset.x, y: crop.offset.y },
      cropSize:   { w: crop.width,    h: crop.height }
    };
  }

  // ExtrudeGeometry için cap (top + bottom face) UV remap. Side wall UV'leri
  // ExtrudeGeometry'nin default mapping'inde kalır (12mm yan kenar — kullanıcı görmez).
  // Top + bottom cap vertex'leri Z ekstrema'larında (zmin / zmax). Bunlar için XY
  // pozisyonu cropped texture'ın UV'sine [0,1] olarak map edilir — texture boyutu
  // = halı boyutu (cropped + padding 1px) → mesh AABB ↔ texture 1:1 hizalı.
  function remapAmorfExtrudeUVs(geom, solved) {
    var pos = geom.attributes.position;
    var uv  = geom.attributes.uv;
    if (!pos || !uv) { console.warn('[AmorfFix] no pos/uv'); return; }
    var zmin = Infinity, zmax = -Infinity;
    for (var i = 0, n = pos.count; i < n; i++) {
      var z = pos.getZ(i);
      if (z < zmin) zmin = z;
      if (z > zmax) zmax = z;
    }
    var zEps = Math.max(1e-6, (zmax - zmin) * 0.05);
    // ar25: UV CROP-COORDINATE FIX. Önceki formül u=(x+halfW)/sizeW → piksel
    // koordinatı olarak u=(px-bbox.x)/bbox.w. Texture ise bbox.x-cropPadding'den
    // başlıyor. Bu offset (cropPadding/bbox.w ≈ %0.5) mesh kenar vertex'lerinin
    // fill alanını (carpet_avg gri) sample etmesine → AR'da kenar gri bandına neden
    // oluyordu. Düzeltme: u=(px-cropX)/cropW = texture ile piksel-perfect eşleme.
    //
    // Dönüşüm zinciri (kaynak canvas piksel koordinatı):
    //   x_3d = (px - bboxCX) * sxM     → px = x_3d * bboxW / sizeW + bboxCX
    //   y_3d = -(py - bboxCY) * syM    → py = -y_3d * bboxH / sizeH + bboxCY
    //   u = (px - cropX) / cropW       (cropX = max(0, bboxX - pad))
    //   v = 1 - (py - cropY) / cropH   (cropY = max(0, bboxY - pad))
    var sizeW = solved.sizeMeters.w;
    var sizeH = solved.sizeMeters.h;
    var bboxW = solved.bboxPx.w, bboxH = solved.bboxPx.h;
    var bboxCX = solved.bboxPx.x + bboxW * 0.5;
    var bboxCY = solved.bboxPx.y + bboxH * 0.5;
    var cropX = solved.cropOffset.x, cropY = solved.cropOffset.y;
    var cropW = solved.cropSize.w,   cropH = solved.cropSize.h;
    var capCount = 0;
    for (var k = 0, nn = pos.count; k < nn; k++) {
      var zk = pos.getZ(k);
      var isCap = (Math.abs(zk - zmax) < zEps) || (Math.abs(zk - zmin) < zEps);
      if (!isCap) continue;
      var x3d = pos.getX(k), y3d = pos.getY(k);
      // 3D metres → source canvas piksel koordinatı
      var px = x3d * bboxW / sizeW + bboxCX;
      var py = -y3d * bboxH / sizeH + bboxCY;
      // Source canvas piksel → texture UV (crop-koordinat bazlı)
      var u = (px - cropX) / cropW;
      var v = 1.0 - (py - cropY) / cropH;
      uv.setXY(k, u, v);
      capCount++;
    }
    uv.needsUpdate = true;
    console.log('[AmorfFix v2.5] UV remap crop-coord', { capVerts: capCount, totalVerts: pos.count, cropX: cropX, cropW: cropW, cropY: cropY, cropH: cropH });
  }

  // AMORF için tam pipeline. buildGeomAndTex'e paralel — aynı bundle formatı döner.
  // pickSourceCanvas çıktısını DOĞRUDAN tüketir (upscale YOK — bilinear upscale
  // kenara feather ekliyor; orijinal sourceCanvas zaten kullanıcının düzenleyici
  // çözünürlüğünde, alpha<96 stripped, AmorfFix için optimal).
  async function buildAmorfBundle(THREE, state, sourceCanvas) {
    var solved = solveAmorfMesh(THREE, sourceCanvas, {
      widthCm: state.widthCm,
      heightCm: state.lengthCm,
      alphaThreshold: 64,     // ar37: 32→64, UV bounds eşiğiyle tutarlı
      solidThreshold: 220,
      preserveThreshold: 8,
      simplifyEpsilon: 0.5,
      smoothIterations: 0,    // ar24: Chaikin kaldırıldı — biye dış kenarı kayıp yok
      cropPadding: 8          // ar37: 3→8. Biye dış antialiased edge'leri crop canvas'a tam dahil.
    });
    if (!solved) {
      throw new Error('Amorf halı analizi başarısız oldu — lütfen önizlemeyi tekrar oluşturun.');
    }

    var preset = MATERIAL_PRESETS[state.qualityCode] || MATERIAL_PRESETS['paradiso-plus'];
    // ar48: thickness ürün metafield/description'dan otomatik okunur (3-25 mm clamp).
    var thickness = resolveThicknessMeters(preset, state.productData);

    // ar54: 4mm → 6mm. AR'da uzaktan bakınca 4mm flat görünüyor (sticker hissi).
    // 6mm gerçek halı kalınlığına yakın, saçak hâlâ kabul edilebilir flat-ish sınırda.
    var thicknessUsed = Math.min(thickness, 0.006);
    var bevelSz = 0;
    var geom = new THREE.ExtrudeGeometry(solved.shape, {
      depth: thicknessUsed,
      bevelEnabled: false,
      bevelThickness: 0,
      bevelSize: 0,
      bevelSegments: 1,
      curveSegments: 24,
      steps: 1
    });
    remapAmorfExtrudeUVs(geom, solved);
    await yieldToUI(); // ar55.14: amorf ExtrudeGeometry sonrası

    // AR floor plane: same transformation as buildGeomAndTex
    geom.rotateX(-Math.PI / 2);
    geom.computeBoundingBox();
    geom.translate(0, -geom.boundingBox.min.y, 0);

    // Texture: hard-cutoff cropped canvas.
    // ar28: augmentCarpetCanvas ile kontrast boost + grain noise → gerçek halı doku hissi.
    // ar50: Amorf USDZ tarafına alpha bleed UYGULA (iOS Quick Look siyah halo fix).
    //       GLB için bypass (Android Scene Viewer doğru render ediyor).
    var augCanvas = augmentCarpetCanvas(solved.croppedCanvas, preset, thickness);
    var imgGlb = await canvasToImage(augCanvas);
    var texGlb = new THREE.Texture(imgGlb);
    configureTexture(THREE, texGlb); // ar49: tek nokta — minFilter=LinearMipmapLinear + mipmaps + anisotropy=16

    // USDZ için ayrı Image+Texture instance (clone yetmez — Image ref aynı kalır)
    // ar50b: alphaOut=255 — silhouette dışı OPAQUE halı_avg ile doldur.
    // Sebep: canvas2D readback alpha PREMULTIPLIED → toDataURL/PNG encode sırasında
    // alpha=0 piksellerin RGB'si tarayıcı tarafından SIFIRLANIYOR (RGB *= alpha/255).
    // Yani alphaOut=0 ile bleed yaptığımız RGB padding'i Image dönüşümünde KAYBOLUYOR
    // → iOS Quick Look'ta yine alpha=0+RGB=0 → bilinear fringe siyah halo.
    // alphaOut=255: alpha kanalı tamamen 255 yazılır → premultiply RGB'yi koruyamaz
    // → halı_avg padding texture'da SAĞLAM kalır → iOS'ta dış kenar gri (siyah değil).
    // Trade-off: saçak ucu AA (alpha 8-127) opaque olur — saçak ucunda yumuşak fade
    // gider, sert kesim gelir. Mesh shape silhouette saçak uçlarına kadar geldiği için
    // saçak görüntüsü RGB'de korunur, sadece arkadaki AR zemini görünmez (gri opaque).
    // Mesh shape sıkı silhouette'i takip ettiği sürece görsel bozulma minimal.
    // ar50d: alphaOut=12 — premultiply round-trip preservation trick.
    // alpha=0 → alpha=12 (CUTOFF 0.05 = 13/255'in HEMEN ALTINDA → discard → SAYDAM).
    // RGB padding round-trip korunur (premult RGB *= 12/255, unpremult *255/12).
    // Bilinear blend zone (silhouette kenar): alpha=(12+255)/2≈133 → render edilir,
    // RGB=halı_avg → siyah halka değil halı renginde yumuşak fade.
    var usdzAmorfCanvas = bleedAlphaTransparent(augCanvas, { alphaOut: 12 });
    var imgUsdz = await canvasToImage(usdzAmorfCanvas);
    var texUsdz = new THREE.Texture(imgUsdz);
    configureTexture(THREE, texUsdz); // ar49: tek nokta — minFilter=LinearMipmapLinear + mipmaps + anisotropy=16

    // ar52/ar53: PREMIUM LOOK — texture-derived normal + roughness + AO map.
    // ar54: AGRESİF parametreler — iOS Quick Look render'ı düşük kontrastlı,
    // konservatif değerler etkisiz kalıyor. Strength 8.0 + AO 0.75 ile belirgin.
    await yieldToUI(); // ar55.14: amorf map generation öncesi
    var pbrSourceCanvas = fitCanvasToMax(augCanvas, PBR_MAP_TARGET_PX);
    var normalCanvas = generateNormalFromTexture(pbrSourceCanvas, 8.0);
    var roughCanvas  = generateRoughnessFromTexture(pbrSourceCanvas, 0.92, 0.20);
    var aoCanvas     = generateAOFromTexture(pbrSourceCanvas, 0.75);
    await yieldToUI(); // ar55.14: amorf map generation sonrası
    var imgNormal = await canvasToImage(normalCanvas);
    var imgRough  = await canvasToImage(roughCanvas);
    var imgAO     = await canvasToImage(aoCanvas);
    var texNormal = new THREE.Texture(imgNormal);
    var texRough  = new THREE.Texture(imgRough);
    var texAO     = new THREE.Texture(imgAO);
    configureTexture(THREE, texNormal);
    configureTexture(THREE, texRough);
    configureTexture(THREE, texAO);
    if (THREE.NoColorSpace !== undefined) {
      texNormal.colorSpace = THREE.NoColorSpace;
      texRough.colorSpace  = THREE.NoColorSpace;
      texAO.colorSpace     = THREE.NoColorSpace;
    } else if (THREE.LinearEncoding !== undefined) {
      texNormal.encoding = THREE.LinearEncoding;
      texRough.encoding  = THREE.LinearEncoding;
      texAO.encoding     = THREE.LinearEncoding;
    }
    texNormal.needsUpdate = true;
    texRough.needsUpdate  = true;
    texAO.needsUpdate     = true;

    // ar39: translate(0,-thickness/2) kaldırıldı — iOS Quick Look bbox min.y'yi
    // zemine koyar. bottom y=0 iken min.y=0 → halı tam zemine oturur.
    // GLB also needs UV2 for its AO map; clone carries it into USDZ.
    if (geom.attributes.uv && !geom.attributes.uv2) {
      geom.setAttribute('uv2', geom.attributes.uv.clone());
    }
    var geomUsdz = geom.clone();
    // ar53: USDZ geom'unu +0.5mm yukarı kaldır — shadow plane Y=0'da kalır,
    // bbox.min.y=+0.0005 oluyor ama Quick Look halıyı yere koyduğunda shadow
    // halının altında zeminde görünür. Halı "yere serilmiş" hissi.
    // DV_AR_USDZ_MIN_Y_ZERO_20260807: geometry already has minY=0; no artificial lift.
    // ar53: AO map için UV2 set et (Three.js aoMap UV2 kullanır).
    if (geomUsdz.attributes.uv && !geomUsdz.attributes.uv2) {
      geomUsdz.setAttribute('uv2', geomUsdz.attributes.uv.clone());
    }

    geom.computeBoundingBox();
    var bbox = geom.boundingBox;
    var halfW = (bbox.max.x - bbox.min.x) / 2;
    var halfH = (bbox.max.z - bbox.min.z) / 2;

    console.log('[AR] amorf bundle (ar53 grounded)', {
      w: state.widthCm, l: state.lengthCm,
      verts: geom.attributes.position.count,
      thicknessMM: +(thicknessUsed * 1000).toFixed(1),
      croppedTex: { w: solved.croppedCanvas.width, h: solved.croppedCanvas.height },
      normalMap: true, roughnessMap: true, aoMap: true, dualShadow: true, lift: '0.5mm'
    });

    return {
      geomGlb: geom, geomUsdz: geomUsdz,
      texGlb: texGlb, texUsdz: texUsdz,
      texNormal: texNormal, texRough: texRough, texAO: texAO,
      halfW: halfW, halfH: halfH,
      preset: preset, thickness: thickness,
      edgeColor: sampleCarpetEdgeColor(THREE, solved.croppedCanvas, preset.sideColor)
    };
  }

  // ═══════════════════ SHAPE → MESH ═══════════════════
  // textureCanvas: opsiyonel — amorf için silhouette trace amacıyla geçilir.
  // Bu yaklaşım mesh sınırını render edilmiş halı görseline birebir hizalar
  // (siyah halka, biye kenar artefaktı, sağ üst kesik gibi sorunların kökünü çözer).
  function buildShape(THREE, state, textureCanvas) {
    var shape = new THREE.Shape();
    var w = state.widthCm / 100; // metre
    var h = state.lengthCm / 100;
    var hw = w / 2, hh = h / 2;

    if (state.shape === 'dikdortgen' || state.shape === 'rectangle') {
      // Hafif yuvarlatılmış köşe (cm cinsinden ~1.5 cm radius, max kısa kenar/12)
      var r = Math.min(0.015, Math.min(w, h) / 12);
      shape.moveTo(-hw + r, -hh);
      shape.lineTo(hw - r, -hh);
      shape.quadraticCurveTo(hw, -hh, hw, -hh + r);
      shape.lineTo(hw, hh - r);
      shape.quadraticCurveTo(hw, hh, hw - r, hh);
      shape.lineTo(-hw + r, hh);
      shape.quadraticCurveTo(-hw, hh, -hw, hh - r);
      shape.lineTo(-hw, -hh + r);
      shape.quadraticCurveTo(-hw, -hh, -hw + r, -hh);
      return shape;
    }
    if (state.shape === 'oval' || state.shape === 'daire' || state.shape === 'circle') {
      // ar47g: ÖNCELİK TERSE ÇEVRİLDİ — matematiksel ellipse/daire PRIMARY, silhouette FALLBACK.
      // Sebep: Önceki silhouette PRIMARY threshold=100 halı texture'ındaki opak saçakları
      // kontur'a dahil ediyordu → mesh 3D ekstrude → kullanıcının raporladığı büyük beyaz
      // üçgen V'ler. Saf matematiksel daire/ellipse halı görseli içeriğinden bağımsız →
      // mesh temiz oval olur, halı saçakları mesh dışında kalır (texture'da görünür ama
      // ekstrude olmaz).
      if (state.shape === 'daire' || state.shape === 'circle') {
        var R = Math.min(hw, hh);
        var segC = 96;
        for (var j = 0; j <= segC; j++) {
          var aa = (j / segC) * Math.PI * 2;
          var xx = R * Math.cos(aa);
          var yy = R * Math.sin(aa);
          if (j === 0) shape.moveTo(xx, yy);
          else shape.lineTo(xx, yy);
        }
      } else {
        var seg = 96;
        for (var i = 0; i <= seg; i++) {
          var a = (i / seg) * Math.PI * 2;
          var x = hw * Math.cos(a);
          var y = hh * Math.sin(a);
          if (i === 0) shape.moveTo(x, y);
          else shape.lineTo(x, y);
        }
      }
      console.log('[AR] daire/oval shape: math PRIMARY (ar47g, saçak-safe)', { shape: state.shape, R: state.shape==='daire'?Math.min(hw,hh):null });
      return shape;
    }
    if (state.shape === 'amorf') {
      // ar47f: ÖNCELİK TERSE ÇEVRİLDİ — amorfContour PRIMARY, silhouette FALLBACK.
      // Sebep: Halı texture'ında opak saçaklar var (Shopify CDN halı görselinin doğal
      // saçakları). Silhouette PRIMARY threshold=220 bu saçakları kontur'a dahil ediyor →
      // mesh 3D ekstrude → kullanıcının gördüğü büyük beyaz üçgen V'ler.
      // Editör konturunu kullanıcı çizdiği saf yuvarlak/oval/amorf → temiz mesh.
      // UV mapping riski: kontur texture'dan ufak farklı olabilir, küçük halo dönebilir
      // ama saçak ekstrude problemine göre çok daha kabul edilir.
      var contour = state.amorfContour;
      if (contour && contour.length >= 8) {
        var TENSION_AMORF = 0.28;
        var pts = [];
        for (var i = 0; i < contour.length; i++) {
          pts.push({
            x: (contour[i][0] - 0.5) * w,
            y: ((1 - contour[i][1]) - 0.5) * h,
          });
        }
        for (var i2 = 0; i2 < pts.length; i2++) {
          var p0 = pts[(i2 - 1 + pts.length) % pts.length];
          var p1 = pts[i2];
          var p2 = pts[(i2 + 1) % pts.length];
          var p3 = pts[(i2 + 2) % pts.length];
          var c1x = p1.x + (p2.x - p0.x) * TENSION_AMORF;
          var c1y = p1.y + (p2.y - p0.y) * TENSION_AMORF;
          var c2x = p2.x - (p3.x - p1.x) * TENSION_AMORF;
          var c2y = p2.y - (p3.y - p1.y) * TENSION_AMORF;
          if (i2 === 0) shape.moveTo(p1.x, p1.y);
          shape.bezierCurveTo(c1x, c1y, c2x, c2y, p2.x, p2.y);
        }
        shape.closePath();
        console.log('[AR] amorf shape: amorfContour PRIMARY (ar47f, saçak-safe)', { pts: pts.length });
        return shape;
      }

      // FALLBACK: silhouette tracing (eski PRIMARY) — sadece amorfContour yoksa
      if (textureCanvas) {
        try {
          var sil = traceAlphaSilhouette(textureCanvas, 220);
          if (sil && sil.points && sil.points.length >= 16) {
            for (var t = 0; t < sil.points.length; t++) {
              var tx = (sil.points[t].nx - 0.5) * w;
              var ty = ((1 - sil.points[t].ny) - 0.5) * h;
              if (t === 0) shape.moveTo(tx, ty);
              else shape.lineTo(tx, ty);
            }
            shape.closePath();
            console.log('[AR] amorf shape: silhouette FALLBACK threshold=220', { pts: sil.points.length });
            return shape;
          }
        } catch (e) {
          console.warn('[AR] silhouette trace fail:', e);
        }
      }

      // SON ÇARE: contour zaten yukarıda denendi, ikinci kez gerekmez
      var contour2 = state.amorfContour;
      if (contour && contour.length >= 8) {
        var TENSION_AMORF = 0.28;
        var pts = [];
        for (var i = 0; i < contour.length; i++) {
          pts.push({
            x: (contour[i][0] - 0.5) * w,
            y: ((1 - contour[i][1]) - 0.5) * h,
          });
        }
        var Npts = pts.length;
        shape.moveTo(pts[0].x, pts[0].y);
        for (var j = 0; j < Npts; j++) {
          var p0 = pts[(j - 1 + Npts) % Npts];
          var p1 = pts[j];
          var p2 = pts[(j + 1) % Npts];
          var p3 = pts[(j + 2) % Npts];
          shape.bezierCurveTo(
            p1.x + TENSION_AMORF * (p2.x - p0.x), p1.y + TENSION_AMORF * (p2.y - p0.y),
            p2.x - TENSION_AMORF * (p3.x - p1.x), p2.y - TENSION_AMORF * (p3.y - p1.y),
            p2.x, p2.y
          );
        }
        shape.closePath();
        console.warn('[AR] amorf shape: amorfContour Cardinal-Bezier FALLBACK (silhouette unavailable)');
        return shape;
      }

      // ÖNCELİK 3: radii fallback (eşit-açı polar interpolasyon).
      var radii = state.amorfRadii || [];
      var N = radii.length;
      if (!N) {
        // Son fallback: oval
        return buildShape(THREE, Object.assign({}, state, { shape: 'oval' }));
      }
      var pts = [];
      for (var k = 0; k < N; k++) {
        var ang = (k / N) * Math.PI * 2;
        pts.push({ x: Math.cos(ang) * radii[k], y: Math.sin(ang) * radii[k] });
      }
      var minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
      for (var m = 0; m < pts.length; m++) {
        if (pts[m].x < minX) minX = pts[m].x;
        if (pts[m].x > maxX) maxX = pts[m].x;
        if (pts[m].y < minY) minY = pts[m].y;
        if (pts[m].y > maxY) maxY = pts[m].y;
      }
      var bw = maxX - minX || 1;
      var bh = maxY - minY || 1;
      var sx = w / bw;
      var sy = h / bh;
      var cxA = (minX + maxX) / 2;
      var cyA = (minY + maxY) / 2;
      for (var n = 0; n < pts.length; n++) {
        var px = (pts[n].x - cxA) * sx;
        var py = (pts[n].y - cyA) * sy;
        if (n === 0) shape.moveTo(px, py);
        else shape.lineTo(px, py);
      }
      shape.closePath();
      return shape;
    }
    // Fallback dikdörtgen
    shape.moveTo(-hw, -hh);
    shape.lineTo(hw, -hh);
    shape.lineTo(hw, hh);
    shape.lineTo(-hw, hh);
    shape.closePath();
    return shape;
  }

  // USDZ texture preprocess: alpha=0 piksellerini carpet ortalama rengiyle doldur.
  // Three.js v0.160 USDZExporter, transparent:false + alphaTest yok kombinasyonunda
  // texture'ın alpha=0 + RGB=0 piksellerini SAF SİYAH olarak render ediyor → halının
  // çevresinde 6cm siyah bant. Çözüm: USDZ'ye verilen texture'da alpha=0 pikselleri
  // halı ortalama rengiyle doldurmak ve tüm alpha'yı 255 yapmak. GLB orijinal kalır
  // (alphaTest:0.1 ile halo'yu zaten atıyor).
  // ar50: Alpha bleed (edge padding) — iOS Quick Look siyah halo fix.
  // Sebep: alpha=0 piksellerin RGB'si genelde (0,0,0). iOS bilinear/mipmap filtering
  // bu siyahı opaque kenarla karıştırınca 4-8 pixel siyah halo doğar. Apple "USDZ
  // edge bleed" tavsiyesi + Three.js USDZExporter issue #30040.
  //
  // Algoritma (review-fix):
  //   - Source = alpha>=128 (opaque). Saçak/AA edge (alpha 8-127) source DEĞİL.
  //   - Hedef = orijinal alpha<8 pikseller. Saçaklar (alpha 8-254) DOKUNULMAZ.
  //   - 4 iter çift-buffer: her iter ÖNCEKİ iter'in mask+RGB'sini input alır
  //     (in-place mutation YOK → ~1 px/iter kontrollü propagation).
  //   - 8-yön komşu opaque (önceki iter'de mask=1 olanlar) RGB ortalaması alınır
  //     → directional bias YOK (first-found değil, average).
  //   - alphaOut=0 (varsayılan): orijinal alpha aynen korunur (cutoff için).
  //   - alphaOut=255: tüm alpha=255 (saçak transparency'sini bozar — kullanma).
  function bleedAlphaTransparent(srcCanvas, opts) {
    opts = opts || {};
    // ar50d: alphaOut=12 — premultiply round-trip preservation trick.
    // canvas2D drawImage premultiplied storage alpha=0 piksellerin RGB'sini siler.
    // alpha=12 verirsek: premult RGB *= 12/255 → unpremult RGB / (12/255) ≈ recover.
    // CUTOFF threshold 0.05 = 12.75/255 → alpha 12 < 13 → DISCARD → SAYDAM.
    // Bilinear blend zone (silhouette kenar): alpha=(12+255)/2≈133 → render edilir,
    // RGB=halı_avg (premultiply round-trip korur) → siyah halka YOK, halı renginde fade.
    var alphaOut = opts.alphaOut;
    if (alphaOut !== 0 && alphaOut !== 12 && alphaOut !== 255) alphaOut = 12;
    var W = srcCanvas.width, H = srcCanvas.height;
    var off = document.createElement('canvas');
    off.width = W; off.height = H;
    var ctx = off.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(srcCanvas, 0, 0);
    var img = ctx.getImageData(0, 0, W, H); // explicit failure if cross-origin tainted
    var d = img.data;
    var N = W * H;

    // Pass 0: orijinal alpha + solid mask snapshot + halı_avg (post-bleed fallback)
    var origAlpha = new Uint8Array(N);
    var maskPrev = new Uint8Array(N); // önceki iter'in solid mask'i
    var solidPx = 0;
    var rSum = 0, gSum = 0, bSum = 0;
    for (var p = 0; p < N; p++) {
      var a = d[p * 4 + 3];
      origAlpha[p] = a;
      if (a >= 128) {
        maskPrev[p] = 1; solidPx++;
        rSum += d[p * 4]; gSum += d[p * 4 + 1]; bSum += d[p * 4 + 2];
      }
    }
    if (solidPx < 100) {
      console.log('[AR-BLEED] az opaque pixel ('+solidPx+') → bypass');
      return srcCanvas;
    }
    var rAvg = (rSum / solidPx) | 0;
    var gAvg = (gSum / solidPx) | 0;
    var bAvg = (bSum / solidPx) | 0;

    // Çift buffer RGB: rgbPrev = okuma kaynağı, RGB yazma off-screen img.data'ya.
    // Her iter sonunda maskPrev güncellenir; RGB değişiklikleri kümülatif (bled
    // pikseller bir sonraki iter'de source olur — geri-okuma mantığı doğru).
    var ITERS = 4, totalBled = 0;
    for (var iter = 0; iter < ITERS; iter++) {
      var maskNext = new Uint8Array(maskPrev); // önceki iter'in tam kopyası
      var iterBled = 0;
      for (var y = 0; y < H; y++) {
        for (var x = 0; x < W; x++) {
          var idx = y * W + x;
          if (maskPrev[idx]) continue;            // zaten source
          if (origAlpha[idx] >= 8) continue;      // saçak/AA edge — DOKUNMA
          var rSum = 0, gSum = 0, bSum = 0, n = 0;
          for (var dy = -1; dy <= 1; dy++) {
            var ny = y + dy;
            if (ny < 0 || ny >= H) continue;
            for (var dx = -1; dx <= 1; dx++) {
              if (dx === 0 && dy === 0) continue;
              var nx = x + dx;
              if (nx < 0 || nx >= W) continue;
              var nidx = ny * W + nx;
              if (!maskPrev[nidx]) continue;       // SADECE önceki iter source'ları
              rSum += d[nidx * 4];
              gSum += d[nidx * 4 + 1];
              bSum += d[nidx * 4 + 2];
              n++;
            }
          }
          if (n > 0) {
            d[idx * 4]     = (rSum / n) | 0;
            d[idx * 4 + 1] = (gSum / n) | 0;
            d[idx * 4 + 2] = (bSum / n) | 0;
            maskNext[idx] = 1; // bir sonraki iter'de source
            iterBled++;
          }
        }
      }
      totalBled += iterBled;
      maskPrev = maskNext;
      if (iterBled === 0) break;
    }

    // Pass fallback: 4 iter sonrası HÂLÂ bled olmamış alpha<8 pikseller
    // (kenardan uzak izole transparent adalar, küçük mip seviyelerinde göze
    // çarpabilir). RGB=halı_avg ile doldur. Saçaklar (alpha>=8) etkilenmez.
    var fallbackPx = 0;
    for (var f = 0; f < N; f++) {
      if (maskPrev[f]) continue;
      if (origAlpha[f] >= 8) continue;
      d[f * 4]     = rAvg;
      d[f * 4 + 1] = gAvg;
      d[f * 4 + 2] = bAvg;
      fallbackPx++;
    }

    // Pass son: alpha kanalı (mode'a göre).
    // alphaOut=0   → orijinal alpha aynen korunur (silhouette dışı RGB padding kayıp riski)
    // alphaOut=12  → ar50d: orijinal alpha>=8 korunur, alpha<8 piksellere alpha=12 ver.
    //                CUTOFF discard (12<13), bilinear blend zone preservation.
    // alphaOut=255 → tüm alpha=255 (opaque, saydamlık YOK)
    if (alphaOut === 0) {
      for (var k = 0; k < N; k++) d[k * 4 + 3] = origAlpha[k];
    } else if (alphaOut === 12) {
      for (var k1 = 0; k1 < N; k1++) {
        d[k1 * 4 + 3] = (origAlpha[k1] >= 8) ? origAlpha[k1] : 12;
      }
    } else {
      for (var k2 = 0; k2 < N; k2++) d[k2 * 4 + 3] = 255;
    }

    ctx.putImageData(img, 0, 0);
    console.log('[AR-BLEED] ar50d', { W: W, H: H, alphaOut: alphaOut, opaqueSeed: solidPx, bledPixels: totalBled, fallbackPixels: fallbackPx, avgRGB: [rAvg, gAvg, bAvg], iters: ITERS });
    return off;
  }

  function preprocessForUsdz(srcCanvas) {
    /* ar50: Tek satırda full alpha bleed. Eski ar45-bleed sadece "alpha<128 + RGB
       siyah" piksellere RGB=halı_avg uyguluyordu — amorf halıların silhouette dışı
       (alpha=0) için yeterli ama kenar dilation yapmıyordu. ar50 bleed 4-iter
       8-yönlü dilation: silhouette dışına ~4 px halı rengi yayılır → iOS Quick Look
       bilinear interpolation siyah halo göstermez. Saçaklar (alpha 8-254) korunur.
       alphaOut=0 → orijinal alpha korunur, cutoff mode (alphaTest=0.05) çalışır. */
    return bleedAlphaTransparent(srcCanvas, { alphaOut: 0 });
    /* eski kod asla calismaz (yukaridaki return) */
    // ar38 (2026-05-01): AI BYPASS detection.
    // theme.liquid'deki dvbInfer (briaai/RMBG-1.4) artık ŞEFFAF PNG döndürüyor
    // (krem çerçeve → alpha=0). Bu texture'da preprocess uygulanırsa şeffaf alanlar
    // halı_avg ile dolar → AR'da gri bant. BYPASS ile alpha kanalı korunur,
    // USDZExporter şeffaflığı USDZ opacity'ye çevirir, iOS Quick Look halı dışını
    // şeffaf render eder (parke/kamera görünür) — kullanıcı talebi.
    try {
      var dW = srcCanvas.width, dH = srcCanvas.height;
      var dOff = document.createElement('canvas');
      dOff.width = dW; dOff.height = dH;
      var dCtx = dOff.getContext('2d');
      dCtx.drawImage(srcCanvas, 0, 0);
      var dImg = dCtx.getImageData(0, 0, dW, dH);
      var dData = dImg.data;
      var transN = 0, sampN = 0;
      // Sample her 4. piksel → hız
      for (var ds = 3; ds < dData.length; ds += 16) {
        sampN++;
        if (dData[ds] < 8) transN++;
      }
      var transRatio = sampN ? (transN / sampN) : 0;
      if (transRatio > 0.03) {
        console.log('[AR] AI texture (RMBG) detected, transp=' + (transRatio*100).toFixed(1) + '% → preprocessForUsdz BYPASS (alpha korunur)');
        return dOff;
      }
    } catch (eAi) { console.warn('[AR] AI detect failed:', eAi.message); }

    // v4 (ar37): İki aşamalı pipeline.
    //
    // SORUN (ar35-ar36): threshold=220 ile alpha 1-219 piksellere carpet_avg (krem/bej)
    // koyuluyordu. Biye iç AA edge (alpha 96-219) mesh içindedir ve krem yapılınca
    // AR'da biye dış kenarında krem band görünüyordu.
    //
    // FİX: Threshold düşürüldü. Aşama:
    //   1) Biye AA edge dahil alpha>=8 pikseller → RGB AYNEN KORUNUR, alpha=255 yapılır.
    //      Bu pikseller biye+halı gövdesi — krem band kaynağı ortadan kalkar.
    //   2) Alpha<8 pikseller (pick sonrası strip ile alpha=0 olan transparent alan) →
    //      bleeding: komşu solid pikselden renk al (biye edge rengi yayılır).
    //      ClampToEdge sampling artıkları için doğru renk (krem değil biye) tekrarlanır.
    //   3) Tüm alpha=255 yapılır (USDZ exporter alpha kanalını yok sayma durumuna karşı).
    var W = srcCanvas.width, H = srcCanvas.height;
    var off = document.createElement('canvas');
    off.width = W; off.height = H;
    var ctx = off.getContext('2d');
    ctx.drawImage(srcCanvas, 0, 0);
    var img;
    try { img = ctx.getImageData(0, 0, W, H); }
    catch (e) { console.warn('[AR] preprocessForUsdz failed:', e.message); return off; }
    var d = img.data;

    // Halı ortalama rengi (solid piksellerden, carpet_avg — bleeding fallback için)
    var rSum = 0, gSum = 0, bSum = 0, count = 0;
    for (var i = 0; i < d.length; i += 16) {
      if (d[i + 3] > 220) { rSum += d[i]; gSum += d[i + 1]; bSum += d[i + 2]; count++; }
    }
    var rAvg = count ? Math.round(rSum / count) : 128;
    var gAvg = count ? Math.round(gSum / count) : 128;
    var bAvg = count ? Math.round(bSum / count) : 128;

    // Pass 1: alpha>=8 piksel RGB koru; alpha<8 piksel geçici olarak carpet_avg ile işaretle.
    // Aynı zamanda "solid" mask oluştur: alpha>=8 piksel indekslerini takip et.
    var isSolid = new Uint8Array(W * H); // 1 = solid, 0 = transparent
    for (var j = 0; j < W * H; j++) {
      var a = d[j * 4 + 3];
      if (a >= 8) {
        isSolid[j] = 1;
        // alpha<255 ise normalize et — iOS USDZ alpha kanalını ignore edebilir
        d[j * 4 + 3] = 255;
      } else {
        // Geçici: carpet_avg (bleeding pass ile üzerine yazılacak)
        d[j * 4] = rAvg; d[j * 4 + 1] = gAvg; d[j * 4 + 2] = bAvg;
        d[j * 4 + 3] = 255;
      }
    }

    // Pass 2: 4-iterasyon inward bleeding.
    // Transparent piksel komşularından (8-yönlü) solid piksel rengi alır.
    // Böylece biye dış edge boyunca biye rengi yayılır (krem değil).
    var ITERS = 4;
    for (var iter = 0; iter < ITERS; iter++) {
      var changed = false;
      for (var y = 0; y < H; y++) {
        for (var x = 0; x < W; x++) {
          var idx = y * W + x;
          if (isSolid[idx]) continue;
          // 8 komşu ara: solid bulunan ilkinden renk al
          var nx2, ny2, ni2;
          var found = false;
          for (var dy = -1; dy <= 1 && !found; dy++) {
            for (var dx = -1; dx <= 1 && !found; dx++) {
              if (dx === 0 && dy === 0) continue;
              nx2 = x + dx; ny2 = y + dy;
              if (nx2 < 0 || nx2 >= W || ny2 < 0 || ny2 >= H) continue;
              ni2 = ny2 * W + nx2;
              if (isSolid[ni2]) {
                d[idx * 4] = d[ni2 * 4];
                d[idx * 4 + 1] = d[ni2 * 4 + 1];
                d[idx * 4 + 2] = d[ni2 * 4 + 2];
                isSolid[idx] = 1; // şimdi solid sayıl (bir sonraki iter için)
                found = true;
                changed = true;
              }
            }
          }
        }
      }
      if (!changed) break;
    }

    ctx.putImageData(img, 0, 0);
    console.log('[AR] USDZ texture preprocess v4', {
      avgRGB: [rAvg, gAvg, bAvg], opaqueSamples: count, W: W, H: H
    });
    return off;
  }

  // ar28: Texture naturalness augmentation.
  // Pixel analizi: gerçek halı luminance std=47, AR giydirme texture std~5 → halı yapay.
  // Bu fonksiyon cropped canvas'ın bir KOPYASINI alır (orijinal değişmez), opaque
  // piksellerde kontrast boost + grain noise uygular → std target ~35-45.
  // Alpha <120 piksel skip → biye/saçak kenarları etkilenmez.
  // preset.grainAmp ve preset.contrastBoost kaliteye göre değişebilir.
  function augmentCarpetCanvas(srcCanvas, preset, thicknessM) {
    var baseBoost = (preset && preset.contrastBoost) || 1.0;
    var baseGrain = (preset && preset.grainAmp)     || 0;
    // ar48: thickness'a göre grain ölçeklendir (≤4mm düz, ≥10mm belirgin hav)
    if (typeof thicknessM === 'number' && thicknessM > 0) {
      baseGrain = baseGrain * grainScaleFromThickness(thicknessM);
    }
    var W = srcCanvas.width, H = srcCanvas.height;
    var dst = document.createElement('canvas');
    dst.width = W; dst.height = H;
    var ctx = dst.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(srcCanvas, 0, 0);
    var imgData = ctx.getImageData(0, 0, W, H);
    var d = imgData.data;
    // ar49: Kaynağın luminance ortalaması VE std değerini ölç (adaptive augment için).
    // Gerçek halı target std~47. Kaynak zaten zenginse (std≥35) augment NO-OP yapar.
    var sum = 0, sumSq = 0, cnt = 0;
    for (var i = 0; i < W * H; i++) {
      if (d[i*4+3] > 120) {
        var lum = d[i*4] * 0.299 + d[i*4+1] * 0.587 + d[i*4+2] * 0.114;
        sum += lum; sumSq += lum * lum; cnt++;
      }
    }
    var mean = cnt > 0 ? sum / cnt : 128;
    var variance = cnt > 0 ? Math.max(0, sumSq / cnt - mean * mean) : 0;
    var srcStd = Math.sqrt(variance);
    // Adaptive: kaynak zaten zengin → augment iptal. Aksi halde fark oranında uygula.
    var STD_TARGET = 35;        // Bu eşik üzerinde artık augmentasyona gerek yok.
    var STD_FULL = 12;          // Bu eşik altında baseBoost/baseGrain tam uygulanır.
    var deficit = Math.max(0, Math.min(1, (STD_TARGET - srcStd) / (STD_TARGET - STD_FULL)));
    var grain = baseGrain * deficit;
    var boost = 1.0 + (baseBoost - 1.0) * deficit;
    console.log('[AR] augmentCarpetCanvas (ar49)', {
      W: W, H: H, srcStd: +srcStd.toFixed(1), mean: +mean.toFixed(1),
      deficit: +deficit.toFixed(2), grainApplied: +grain.toFixed(1), boostApplied: +boost.toFixed(2)
    });
    if (boost <= 1.01 && grain < 1) {
      console.log('[AR] augment NO-OP (kaynak zaten zengin)');
      return srcCanvas;
    }
    for (var i = 0; i < W * H; i++) {
      if (d[i*4+3] < 120) continue;
      var n = (Math.random() - 0.5) * grain;
      d[i*4]   = Math.max(0, Math.min(255, Math.round((d[i*4]   - mean) * boost + mean + n)));
      d[i*4+1] = Math.max(0, Math.min(255, Math.round((d[i*4+1] - mean) * boost + mean + n)));
      d[i*4+2] = Math.max(0, Math.min(255, Math.round((d[i*4+2] - mean) * boost + mean + n)));
    }
    ctx.putImageData(imgData, 0, 0);
    return dst;
  }

  // Canvas → HTMLImageElement. PNG kullanıyoruz çünkü amorf texture'ında alpha
  // (transparent çevre) kritik — JPEG alpha'yı kaybeder ve siyah arka plan üretir.
  function canvasToImage(canvas) {
    return new Promise(function (resolve, reject) {
      try {
        var dataURL = canvas.toDataURL('image/png');
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function () { resolve(img); };
        img.onerror = function (e) { reject(new Error('texture image yüklenemedi')); };
        img.src = dataURL;
      } catch (e) { reject(e); }
    });
  }

  // Canvas içindeki alpha>0 piksellerinin bbox'ını ölç (normalize 0-1).
  // Subsample (her 8. pikseli oku) — 4K canvas'ta hızlı kalsın.
  // Amorf için: __amorfLastPreviewDataUrl PNG'sinde halı sadece bir kısmı kaplar,
  // etrafı transparent. Bu bbox'u UV haritalamasında kullanıp mesh shape'i halıya
  // birebir hizalıyoruz (yoksa mesh dış kısmı transparent UV'ye düşer ve siyah olur).
  function measureAlphaBBox(canvas, alphaThreshold, padPx) {
    // alphaThreshold: alpha bu değerin üstündeki pikseller bbox'a dahil edilir.
    //   - 96 (default): silhouette tracing ile uyumlu (yumuşak kenar yakalar)
    //   - 220 (sıkı): sadece kesin opaque pikseller (halı/biye iç kısmı), feather hariç
    // padPx: bbox kenar genişletmesi (piksel)
    //   - null (default): step kadar genişlet (eski davranış, "yumuşak kenar ringi" için)
    //   - 0: hiç genişletme
    //   - negatif (örn. -2): bbox'ı sıkıştır (feather'dan iyice arındırma için)
    var thr = alphaThreshold || 96;
    try {
      var w = canvas.width, h = canvas.height;
      var ctx = canvas.getContext('2d', { willReadFrequently: true });
      var data = ctx.getImageData(0, 0, w, h).data;
      var minX = w, minY = h, maxX = -1, maxY = -1;
      var step = Math.max(1, Math.floor(Math.min(w, h) / 512)); // ar18: 256→512 — UV bbox subsample bias 4px→1px
      for (var y = 0; y < h; y += step) {
        for (var x = 0; x < w; x += step) {
          var a = data[(y * w + x) * 4 + 3];
          if (a > thr) {
            if (x < minX) minX = x;
            if (x > maxX) maxX = x;
            if (y < minY) minY = y;
            if (y > maxY) maxY = y;
          }
        }
      }
      if (maxX < 0) return { uMin: 0, uMax: 1, vMin: 0, vMax: 1, opaque: true };
      var pad = (padPx == null) ? step : padPx;
      minX = Math.max(0, minX - pad);
      minY = Math.max(0, minY - pad);
      maxX = Math.min(w - 1, maxX + pad);
      maxY = Math.min(h - 1, maxY + pad);
      // Sıkıştırma sonrası geçersiz bbox kontrolü (negatif pad çok büyükse)
      if (maxX <= minX || maxY <= minY) {
        return { uMin: 0, uMax: 1, vMin: 0, vMax: 1, opaque: true };
      }
      return {
        uMin: minX / w, uMax: (maxX + 1) / w,
        vMin: minY / h, vMax: (maxY + 1) / h,
        opaque: false,
      };
    } catch (e) {
      console.warn('[AR] alpha bbox ölçülemedi, full canvas kullanılıyor', e);
      return { uMin: 0, uMax: 1, vMin: 0, vMax: 1, opaque: true };
    }
  }

  async function buildGeomAndTex(THREE, state, textureCanvas) {
    var preset = MATERIAL_PRESETS[state.qualityCode] || MATERIAL_PRESETS['paradiso-plus'];
    // ar48: thickness ürün metafield/description'dan otomatik okunur.
    var thickness = resolveThicknessMeters(preset, state.productData);
    // textureCanvas'ı buildShape'e veriyoruz: amorf için silhouette trace edebilsin.
    var shape = buildShape(THREE, state, textureCanvas);

    var bevelSz = computeBevelSize(thickness);
    // ar33-revert: bevelOffset kaldırıldı — Three.js ExtrudeGeometry karmaşık shape'te
    // (özellikle amorf) self-intersect üretiyor → AR açılmıyor. Bevel default mode.
    // Boyut düzeltmesi mesh-level scale (geom.scale) ile yapılır aşağıda.
    var geom = new THREE.ExtrudeGeometry(shape, {
      depth: thickness,
      bevelEnabled: true,
      bevelThickness: bevelSz * 1.2,
      bevelSize: bevelSz,
      bevelSegments: 3,
      curveSegments: 24,
      steps: 1,
    });
    await yieldToUI(); // ar55.14: ExtrudeGeometry ağır — UI'a nefes ver

    // UV NORMALIZATION
    // 1) Önce texture canvas'ta halının gerçek bbox'ını ölç (alpha>0 piksel sınırları).
    //    Dikdörtgen/oval/daire için canvas opaque olur → bbox = full (uMin=0,uMax=1).
    //    Amorf için __amorfLastPreviewDataUrl genellikle transparent dış alanlı PNG.
    // 2) Mesh shape pozisyonunu mesh-bbox normalize et (sN ∈ [0,1]).
    // 3) UV = lerp(uMin..uMax, sN). Böylece mesh'in shape'i texture içindeki halıya
    //    birebir oturur. Mesh'in shape dışında zaten triangle'ı yok; bbox dışı UV
    //    sıfır oluyor. Halı dışı transparent piksellere alphaTest fallback.
    // Her shape için pixel-perfect halı/biye dış sınırını bul (sıkı threshold 220).
    // Hotspot mantığı: mesh kenarı = halı dış kenarı, ötesinde AR sahne zemini.
    // 220: feather (alpha 50-200, upscale bilinear interpolation artığı) bbox dışı,
    // halı/biye opaque (alpha 220+) bbox içi. Beyaz/siyah/krem çerçeve fiziksel olarak
    // imkansız çünkü mesh hiçbir UV koordinatında halı dışı texture sample etmez.
    // Eski davranış (dikdörtgen için opaque:true = full canvas UV) yanlış varsayımdı:
    // canvas'ta halı %50-80 alanı kaplıyor, etrafı transparent feather → mesh kenarı
    // bu feather'ı sample ediyordu (siyah/beyaz/krem oluyordu).
    // padPx = -2: bbox'ı 2 piksel SIKAR. Threshold 220 zaten feather'ı dışlıyor ama
    // measureAlphaBBox'ın default step padding'i feather'ı geri sokuyordu (ar11'de
    // mesh kenarında ince krem şerit). 2 piksel @ 2048 texture = halı boyutunun %0.1'i
    // (200cm halıda 2mm) — görsel kayıp yok, feather tamamen elenir.
    // ar35: threshold 220→64, pad -2→+4.
    // 220 çok sıkıydı: biye/overlok antialiased kenar pikselleri (alpha ~80-210) bbox dışı kalıp
    // mesh onları kapsayamıyordu → AR'da kenar "kesilmiş" görünüm.
    // 64: biye/overlok şeridinin tüm alpha'lı pikselleri dahil.
    // ar37: pad +4→+8. UV sınırını mesh silhouette sınırından (threshold=96) biraz geniş tut.
    // Mesh α=96 threshold → mesh biraz içeride → UV padding=8 ile UV hep mesh'i kapsar.
    // Net etki: biye tam görünür, mesh kenarda UV dışına çıkmaz → taşma/gri artifact yok.
    var alphaBbox = measureAlphaBBox(textureCanvas, 64, 8);

    geom.computeBoundingBox();
    var bb = geom.boundingBox;
    var bbW = (bb.max.x - bb.min.x) || 1;
    var bbH = (bb.max.y - bb.min.y) || 1;
    var uW = alphaBbox.uMax - alphaBbox.uMin;
    var vH = alphaBbox.vMax - alphaBbox.vMin;
    var posAttr = geom.attributes.position;
    var uvAttr = geom.attributes.uv;
    for (var vi = 0; vi < posAttr.count; vi++) {
      var px = posAttr.getX(vi);
      var py = posAttr.getY(vi);
      var sN = (px - bb.min.x) / bbW;        // mesh-x normalize 0..1
      var tN = 1 - (py - bb.min.y) / bbH;     // mesh-y flip → texture v 0..1
      uvAttr.setXY(vi, alphaBbox.uMin + sN * uW, alphaBbox.vMin + tN * vH);
    }
    uvAttr.needsUpdate = true;
    console.log('[AR] UV', { shape: state.shape, alphaBbox: alphaBbox });

    // AR yer planı: XZ düzlemi, +Y yukarı.
    // rotateX(-PI/2): (x,y,z) -> (x,z,-y). Top face normal +Z -> +Y (yukarı).
    // translate(0, thickness, 0): bottom face y=0 (yer), top y=thickness.
    // AR yer plani: rotateX(-PI/2) + bbox-relative translate
    // ExtrudeGeometry +Z extrude -> rotateX sonrasi bottom y=0, top y=thickness.
    // Bbox-relative translate ile her durumda halinin alt yuzu y=0 (yere oturur).
    geom.rotateX(-Math.PI / 2);
    geom.computeBoundingBox();
    var exactBox = geom.boundingBox;
    var actualWidth = (exactBox.max.x - exactBox.min.x) || 1;
    var actualHeight = (exactBox.max.y - exactBox.min.y) || 1;
    var actualLength = (exactBox.max.z - exactBox.min.z) || 1;
    var exactScaleX = (state.widthCm / 100) / actualWidth;
    var exactScaleY = thickness / actualHeight;
    var exactScaleZ = (state.lengthCm / 100) / actualLength;
    geom.scale(exactScaleX, exactScaleY, exactScaleZ);
    geom.computeBoundingBox();
    var exactCenterX = (geom.boundingBox.min.x + geom.boundingBox.max.x) / 2;
    var exactCenterZ = (geom.boundingBox.min.z + geom.boundingBox.max.z) / 2;
    geom.translate(-exactCenterX, -geom.boundingBox.min.y, -exactCenterZ);
    geom.computeBoundingBox();
    console.log('[DVB-AR] exact grounded bounds:', {
      widthM: geom.boundingBox.max.x - geom.boundingBox.min.x,
      lengthM: geom.boundingBox.max.z - geom.boundingBox.min.z,
      thicknessM: geom.boundingBox.max.y - geom.boundingBox.min.y,
      minY: geom.boundingBox.min.y
    });

    // === GLB için texture — ar28: augmentCarpetCanvas ile doku zenginleştirme ===
    var augGlbCanvas = augmentCarpetCanvas(textureCanvas, preset, thickness);
    var safeGlbCanvas = bleedAlphaTransparent(augGlbCanvas, { alphaOut: 0 });
    var imgGlb = await canvasToImage(safeGlbCanvas);
    var texGlb = new THREE.Texture(imgGlb);
    configureTexture(THREE, texGlb); // ar49: tek nokta — minFilter=LinearMipmapLinear + mipmaps + anisotropy=16

    // === USDZ için preprocess edilmiş texture ===
    // ar50: bleed AUGMENT SONRA uygulanır. Eski sıra (preprocess→augment) bazı
    // tarayıcılarda augmentCarpetCanvas yeniden drawImage yaparken alpha=0
    // pikseldeki RGB padding'i kaybedebiliyordu. Önce augment, sonra bleed →
    // bleed çıktısı doğrudan canvasToImage'e gider, RGB padding korunur.
    var augUsdzCanvas = augmentCarpetCanvas(textureCanvas, preset, thickness);
    // ar50d: alphaOut=12 — saydamlık + bilinear halo preservation (bkz amorf path)
    var bledUsdzCanvas = bleedAlphaTransparent(augUsdzCanvas, { alphaOut: 12 });
    var imgUsdz = await canvasToImage(bledUsdzCanvas);
    var texUsdz = new THREE.Texture(imgUsdz);
    configureTexture(THREE, texUsdz); // ar49: tek nokta — minFilter=LinearMipmapLinear + mipmaps + anisotropy=16

    // ar52/ar53: PREMIUM LOOK — texture-derived normal + roughness + AO map.
    // ar54: AGRESİF parametreler (bkz amorf path).
    await yieldToUI(); // ar55.14: texture işlemleri öncesi UI'ya nefes ver
    var pbrSourceCanvas = fitCanvasToMax(augUsdzCanvas, PBR_MAP_TARGET_PX);
    var normalCanvas = generateNormalFromTexture(pbrSourceCanvas, 8.0);
    var roughCanvas  = generateRoughnessFromTexture(pbrSourceCanvas, 0.92, 0.20);
    var aoCanvas     = generateAOFromTexture(pbrSourceCanvas, 0.75);
    await yieldToUI(); // ar55.14: map generation sonrası
    var imgNormal = await canvasToImage(normalCanvas);
    var imgRough  = await canvasToImage(roughCanvas);
    var imgAO     = await canvasToImage(aoCanvas);
    var texNormal = new THREE.Texture(imgNormal);
    var texRough  = new THREE.Texture(imgRough);
    var texAO     = new THREE.Texture(imgAO);
    configureTexture(THREE, texNormal);
    configureTexture(THREE, texRough);
    configureTexture(THREE, texAO);
    if (THREE.NoColorSpace !== undefined) {
      texNormal.colorSpace = THREE.NoColorSpace;
      texRough.colorSpace  = THREE.NoColorSpace;
      texAO.colorSpace     = THREE.NoColorSpace;
    } else if (THREE.LinearEncoding !== undefined) {
      texNormal.encoding = THREE.LinearEncoding;
      texRough.encoding  = THREE.LinearEncoding;
      texAO.encoding     = THREE.LinearEncoding;
    }
    texNormal.needsUpdate = true;
    texRough.needsUpdate  = true;
    texAO.needsUpdate     = true;

    // === USDZ için ayrı geometry ===
    // ar39: translate(0, -thickness/2, 0) kaldırıldı.
    // iOS Quick Look bbox min.y'yi zemin düzlemine koyar (origin değil).
    // bottom y=0 → min.y=0 → zemine tam oturur. -thickness/2 ile min.y=-0.001 oluyordu
    // ve Quick Look +1mm kaldırıyordu → halı 1mm havada görünüyordu.
    // GLB için geom orijinal halinde (bottom y=0) kaldı.
    // GLB also needs UV2 for its AO map; clone carries it into USDZ.
    if (geom.attributes.uv && !geom.attributes.uv2) {
      geom.setAttribute('uv2', geom.attributes.uv.clone());
    }
    var geomUsdz = geom.clone();
    // ar53: USDZ geom +0.5mm yukarı (yere serilme + shadow yere yerleşsin)
    // DV_AR_USDZ_MIN_Y_ZERO_20260807: geometry already has minY=0; no artificial lift.
    // ar53: AO map için UV2 attribute set et.
    if (geomUsdz.attributes.uv && !geomUsdz.attributes.uv2) {
      geomUsdz.setAttribute('uv2', geomUsdz.attributes.uv.clone());
    }

    geom.computeBoundingBox();
    var bbox = geom.boundingBox;
    var halfW = (bbox.max.x - bbox.min.x) / 2;
    var halfH = (bbox.max.z - bbox.min.z) / 2;

    console.log('[AR] geom+tex hazir (ar53 grounded)',
      { shape: state.shape, w: state.widthCm, l: state.lengthCm,
        verts: posAttr.count, thickness: thickness,
        normalMap: true, roughnessMap: true, aoMap: true, dualShadow: true });
    return {
      geomGlb: geom, geomUsdz: geomUsdz,
      texGlb: texGlb, texUsdz: texUsdz,
      texNormal: texNormal, texRough: texRough, texAO: texAO,
      halfW: halfW, halfH: halfH,
      preset: preset, thickness: thickness,
      edgeColor: sampleCarpetEdgeColor(THREE, textureCanvas, preset.sideColor),
    };
  }

  // ═══════════════════ ar52: PREMIUM LOOK HELPERS ═══════════════════
  // Halıyı CANLI/GERÇEKÇİ göstermek için 3 katman:
  //  1) Texture-derived NORMAL MAP (Sobel)  — desenden gerçek hav/derinlik illüzyonu.
  //  2) Texture-derived ROUGHNESS MAP        — açık alanlar mat, koyu alanlar hafif parıltı.
  //  3) Soft GROUND SHADOW PLANE             — halı yere oturma hissi, havada uçmaz.
  // Bu üçü birlikte halı dokusu, kalınlık ve hissiyatı ciddi şekilde artırır.

  // Texture'dan Sobel filter ile normal map üret. Halı desenini ve havını TAKIP eder
  // (generic noise normal map'inden çok daha gerçekçi). Alpha aware: alpha<32 piksel
  // düz normal (0,0,1) yazar — saçak dışı boşluk düzgün görünür.
  function generateNormalFromTexture(srcCanvas, strength) {
    var W = srcCanvas.width, H = srcCanvas.height;
    var ctx = srcCanvas.getContext('2d', { willReadFrequently: true });
    var img = ctx.getImageData(0, 0, W, H);
    var src = img.data;
    var lum = new Float32Array(W * H);
    var alpha = new Uint8Array(W * H);
    for (var i = 0, j = 0; i < lum.length; i++, j += 4) {
      lum[i] = (src[j] * 0.299 + src[j+1] * 0.587 + src[j+2] * 0.114) / 255;
      alpha[i] = src[j+3];
    }
    var nCanvas = document.createElement('canvas');
    nCanvas.width = W; nCanvas.height = H;
    var nctx = nCanvas.getContext('2d');
    var nimg = nctx.createImageData(W, H);
    var nd = nimg.data;
    for (var y = 0; y < H; y++) {
      for (var x = 0; x < W; x++) {
        var idx = y * W + x;
        var oi = idx * 4;
        if (x === 0 || y === 0 || x === W - 1 || y === H - 1 || alpha[idx] < 32) {
          nd[oi] = 128; nd[oi+1] = 128; nd[oi+2] = 255; nd[oi+3] = 255;
          continue;
        }
        var tl = lum[idx - W - 1], tc = lum[idx - W], tr = lum[idx - W + 1];
        var ml = lum[idx - 1],     mr = lum[idx + 1];
        var bl = lum[idx + W - 1], bc = lum[idx + W], br = lum[idx + W + 1];
        var dx = (tr + 2*mr + br) - (tl + 2*ml + bl);
        var dy = (bl + 2*bc + br) - (tl + 2*tc + tr);
        // ar53: alpha-aware strength. Saçak edge zone (alpha 64-200) için 1.8x güç:
        // her saçak iplik ayrı ipek tutamı gibi belirginleşsin (gerçek halı saçak hissi).
        var localStrength = strength;
        var a = alpha[idx];
        if (a >= 64 && a < 200) {
          localStrength *= 1.8;
        }
        var nx = -dx * localStrength;
        var ny = -dy * localStrength;
        var nz = 1.0;
        var len = Math.sqrt(nx*nx + ny*ny + nz*nz) || 1;
        nd[oi]   = Math.round(((nx/len) * 0.5 + 0.5) * 255);
        nd[oi+1] = Math.round(((ny/len) * 0.5 + 0.5) * 255);
        nd[oi+2] = Math.round(((nz/len) * 0.5 + 0.5) * 255);
        nd[oi+3] = 255;
      }
    }
    nctx.putImageData(nimg, 0, 0);
    return nCanvas;
  }

  // ar53: Texture'dan AO (Ambient Occlusion) map üret. Desen kenarlarında ve koyu
  // bölgelerde gölge efekti → yıldız/roket/bulut desenleri 3D kabarık görünür,
  // hav hissi belirginleşir. PBR'da map çarpan rolünde (1.0=ışık geçer, 0=gölge).
  // Yöntem: luminance'tan hafif "valley darkening" — koyu desenler daha gölgeli görünür,
  // açık alanlar tam aydınlık. Plus: laplacian edge detection ile desen kenarları vurgulu.
  function generateAOFromTexture(srcCanvas, intensity) {
    var W = srcCanvas.width, H = srcCanvas.height;
    var ctx = srcCanvas.getContext('2d', { willReadFrequently: true });
    var img = ctx.getImageData(0, 0, W, H);
    var src = img.data;
    var lum = new Float32Array(W * H);
    var alpha = new Uint8Array(W * H);
    for (var i = 0, j = 0; i < lum.length; i++, j += 4) {
      lum[i] = (src[j] * 0.299 + src[j+1] * 0.587 + src[j+2] * 0.114) / 255;
      alpha[i] = src[j+3];
    }
    var aCanvas = document.createElement('canvas');
    aCanvas.width = W; aCanvas.height = H;
    var actx = aCanvas.getContext('2d');
    var aimg = actx.createImageData(W, H);
    var ad = aimg.data;
    var k = Math.max(0, Math.min(1, intensity || 0.5));
    for (var y = 0; y < H; y++) {
      for (var x = 0; x < W; x++) {
        var idx = y * W + x;
        var oi = idx * 4;
        if (alpha[idx] < 32) {
          // Halı dışı tam ışık (AO yok)
          ad[oi] = 255; ad[oi+1] = 255; ad[oi+2] = 255; ad[oi+3] = 255;
          continue;
        }
        // Base AO: koyu pikseller daha gölgeli (1 - (1-lum)*k * 0.6)
        var base = 1.0 - (1.0 - lum[idx]) * k * 0.6;
        // Edge enhance: laplacian — desen kenarları daha koyu (3D vurgu)
        var edge = 0;
        if (x > 0 && y > 0 && x < W - 1 && y < H - 1) {
          edge = Math.abs(4 * lum[idx] - lum[idx-1] - lum[idx+1] - lum[idx-W] - lum[idx+W]);
          base -= edge * k * 0.8;
        }
        if (base < 0.45) base = 0.45;
        if (base > 1.0)  base = 1.0;
        var v = Math.round(base * 255);
        ad[oi] = v; ad[oi+1] = v; ad[oi+2] = v; ad[oi+3] = 255;
      }
    }
    actx.putImageData(aimg, 0, 0);
    return aCanvas;
  }

  // Texture luminance'a göre roughness map üret. Halıda açık tüyler genelde mat,
  // koyu tüyler ışıkta hafif parıldar. Sabit roughness yerine bu varyasyon
  // PBR render'ı çok daha doğal yapar.
  function generateRoughnessFromTexture(srcCanvas, baseRough, variance) {
    var W = srcCanvas.width, H = srcCanvas.height;
    var ctx = srcCanvas.getContext('2d', { willReadFrequently: true });
    var img = ctx.getImageData(0, 0, W, H);
    var src = img.data;
    var rCanvas = document.createElement('canvas');
    rCanvas.width = W; rCanvas.height = H;
    var rctx = rCanvas.getContext('2d');
    var rimg = rctx.createImageData(W, H);
    var rd = rimg.data;
    for (var i = 0, j = 0; i < W * H; i++, j += 4) {
      var lum = (src[j] * 0.299 + src[j+1] * 0.587 + src[j+2] * 0.114) / 255;
      // Açık alanlar (lum>0.5) mat (yüksek roughness), koyu alanlar daha az roughness
      var rough = baseRough + (lum - 0.5) * variance;
      if (rough < 0.45) rough = 0.45;
      if (rough > 1.0)  rough = 1.0;
      var v = Math.round(rough * 255);
      rd[j] = v; rd[j+1] = v; rd[j+2] = v; rd[j+3] = 255;
    }
    rctx.putImageData(rimg, 0, 0);
    return rCanvas;
  }

  // ar53: Tek plane yerine ÇİFT katmanlı gölge — gerçek halıdaki yere serilme hissi.
  //  - Inner contact shadow: 1.04x boyut, koyu+sıkı (kenara yapışık temas izi).
  //  - Outer soft shadow:    1.25x boyut, açık+geniş (ortam ışık dağılımı).
  // İkisi üst üste eklenince halı kenarı yere "yapışıyor" görünür, fotoğraftaki gibi.
  // Plane Y=0 (zemin seviyesi). Halı USDZ geometry +0.5mm lift edilir → bbox.min.y=0
  // Quick Look halıyı yere koyar, shadow doğal olarak halı altında görünür.
  function createShadowPlane(THREE, halfW, halfH, opts) {
    var size = 256;
    var canvas = document.createElement('canvas');
    canvas.width = size; canvas.height = size;
    var ctx = canvas.getContext('2d');
    var inR = size * (opts.innerR || 0.30);
    var outR = size * (opts.outerR || 0.50);
    var grad = ctx.createRadialGradient(size/2, size/2, inR, size/2, size/2, outR);
    grad.addColorStop(0,    'rgba(0,0,0,' + opts.opacity + ')');
    grad.addColorStop(0.55, 'rgba(0,0,0,' + (opts.opacity * (opts.midMul || 0.55)) + ')');
    grad.addColorStop(1,    'rgba(0,0,0,0)');
    ctx.fillStyle = grad;
    ctx.fillRect(0, 0, size, size);
    var tex = new THREE.CanvasTexture(canvas);
    if (THREE.SRGBColorSpace !== undefined) tex.colorSpace = THREE.SRGBColorSpace;
    var pad = opts.pad;
    var planeW = halfW * 2 * pad;
    var planeH = halfH * 2 * pad;
    var geom = new THREE.PlaneGeometry(planeW, planeH);
    geom.rotateX(-Math.PI / 2); // XZ düzlemi
    var mat = new THREE.MeshBasicMaterial({
      map: tex,
      transparent: true,
      opacity: 1.0,
      depthWrite: false,
      side: THREE.DoubleSide,
    });
    var mesh = new THREE.Mesh(geom, mat);
    mesh.position.y = opts.y || 0;
    mesh.renderOrder = opts.renderOrder || -1;
    return mesh;
  }

  // ar54: ÜÇ katmanlı gölge — gerçek beton zemin üzerinde halı temas izi için
  // çok koyu sıkı kontak + orta + geniş soft. Önceki çift katman zayıf kalıyordu.
  function createDualGroundShadow(THREE, halfW, halfH) {
    var group = new THREE.Group();
    // Inner contact: çok dar (1.02x), çok koyu (0.85) — halı kenarına yapışık ince çizgi
    var inner = createShadowPlane(THREE, halfW, halfH, {
      pad: 1.02, innerR: 0.45, outerR: 0.50, midMul: 0.85,
      opacity: 0.85, y: 0.00008, renderOrder: -1
    });
    // Mid contact: ana gölge (1.12x), orta koyu (0.50)
    var mid = createShadowPlane(THREE, halfW, halfH, {
      pad: 1.12, innerR: 0.35, outerR: 0.50, midMul: 0.65,
      opacity: 0.50, y: 0.00005, renderOrder: -2
    });
    // Outer soft: geniş yumuşak (1.50x), ortam dağılımı (0.30)
    var soft = createShadowPlane(THREE, halfW, halfH, {
      pad: 1.50, innerR: 0.18, outerR: 0.50, midMul: 0.40,
      opacity: 0.30, y: 0.00002, renderOrder: -3
    });
    group.add(soft);
    group.add(mid);
    group.add(inner);
    return group;
  }

  // ar26: Procedural carpet normal map.
  // PBR halı dokusu için kritik. Top color texture düz görünmesin diye mikro-perturbations
  // ekler — halı havı (pile) simüle eder. Her piksel ~1mm halı yüzey detayı.
  // Anisotropic bias: Y ekseninde daha fazla varyasyon (havlar genelde dikey yönlü).
  // Normal map sRGB değil → colorSpace = NoColorSpace (linear).
  // 1024x1024: halı boyutuna göre 1-2mm/piksel detay (insan gözünün havı algıladığı boy).
  // ar27: Geliştirilmiş carpet normal map.
  // Salt random noise yerine: COARSE sweep (büy��k dalga, "hav tufası") + FINE noise karışımı.
  // Gerçek halı havı: birden fazla ölçekte yönlü bozulma. Coarse = tüy yönü dalgalanmaları,
  // fine = tek tüy titreşimleri. Y-bias: halı havları çoğunlukla dikey yönlü.
  function createCarpetNormalTexture(THREE) {
    var size = 512;
    var canvas = document.createElement('canvas');
    canvas.width = size; canvas.height = size;
    var ctx = canvas.getContext('2d');
    var img = ctx.createImageData(size, size);
    var d = img.data;

    // Coarse grid: 20x20 hücre → büyük dalgalı "sweep" pattern
    var CS = 20;
    var cNX = new Float32Array(CS * CS);
    var cNY = new Float32Array(CS * CS);
    for (var ci = 0; ci < CS * CS; ci++) {
      cNX[ci] = (Math.random() - 0.5) * 0.5;
      cNY[ci] = (Math.random() - 0.5) * 0.75; // daha güçlü Y sweep
    }

    for (var row = 0; row < size; row++) {
      for (var col = 0; col < size; col++) {
        // Bilinear interpolation on coarse grid
        var fx = (col / size) * (CS - 1);
        var fy = (row / size) * (CS - 1);
        var x0 = Math.floor(fx), y0 = Math.floor(fy);
        var x1 = Math.min(x0 + 1, CS - 1), y1 = Math.min(y0 + 1, CS - 1);
        var tx = fx - x0, ty = fy - y0;
        var coarseNX = cNX[y0*CS+x0]*(1-tx)*(1-ty) + cNX[y0*CS+x1]*tx*(1-ty) +
                       cNX[y1*CS+x0]*(1-tx)*ty    + cNX[y1*CS+x1]*tx*ty;
        var coarseNY = cNY[y0*CS+x0]*(1-tx)*(1-ty) + cNY[y0*CS+x1]*tx*(1-ty) +
                       cNY[y1*CS+x0]*(1-tx)*ty    + cNY[y1*CS+x1]*tx*ty;
        // Fine noise (single pile)
        var fNX = (Math.random() - 0.5) * 0.15;
        var fNY = (Math.random() - 0.5) * 0.20;
        // Blend 65% coarse (sweep) + 35% fine (individual pile)
        var nx = coarseNX * 0.65 + fNX * 0.35;
        var ny = coarseNY * 0.65 + fNY * 0.35;
        var nz = Math.sqrt(Math.max(0.35, 1 - nx*nx - ny*ny));
        var idx = (row * size + col) * 4;
        d[idx]   = Math.round((nx * 0.5 + 0.5) * 255);
        d[idx+1] = Math.round((ny * 0.5 + 0.5) * 255);
        d[idx+2] = Math.round((nz * 0.5 + 0.5) * 255);
        d[idx+3] = 255;
      }
    }
    ctx.putImageData(img, 0, 0);
    var tex = new THREE.CanvasTexture(canvas);
    tex.wrapS = THREE.RepeatWrapping;
    tex.wrapT = THREE.RepeatWrapping;
    tex.anisotropy = 16;
    if (THREE.NoColorSpace !== undefined) tex.colorSpace = THREE.NoColorSpace;
    else if (THREE.LinearEncoding !== undefined) tex.encoding = THREE.LinearEncoding;
    tex.needsUpdate = true;
    return tex;
  }

  // GLB için: top texture + yan kenar farklı renk (multi-material array).
  // alphaTest 0.1 — mesh shape silhouette trace ile texture'a birebir oturduğu için
  // halı içinde transparent piksel kalmaz; sadece dış kenardaki saçaklı transparent
  // halo'yu atmak yeter. 0.5 yumuşak biye kenarını yiyordu (zigzag); 0.1 antialiased
  // gradient'i korur ama halı dışındaki halo'yu atar.
  // ar27: MeshPhysicalMaterial + sheen — halı "velvet / pufidik" efekti.
  // sheen: havlı yüzeylerde ışık dağılımı (retroreflection). Halı için ideal.
  // GLB (model-viewer) sheen destekler. USDZ USDZExporter sheen'i export etmez
  // ama model boş gelmez — diğer PBR parametreler (roughness, normalMap) kalır.
  // DV_AR_PBR_MAP_SAFE_GROUNDED_20260807
  // The visible side wall uses the product image boundary itself. This closes the
  // physical gap between the 7 mm top surface and the floor without inventing a
  // generic brown/black edge that would change the product colour.
  function sampleCarpetEdgeColor(THREE, canvas, fallbackHex) {
    try {
      var ctx = canvas.getContext('2d', { willReadFrequently: true });
      var W = canvas.width, H = canvas.height;
      var d = ctx.getImageData(0, 0, W, H).data;
      var sumR = 0, sumG = 0, sumB = 0, count = 0;
      function alphaAt(x, y) {
        if (x < 0 || y < 0 || x >= W || y >= H) return 0;
        return d[(y * W + x) * 4 + 3];
      }
      for (var y = 0; y < H; y++) {
        for (var x = 0; x < W; x++) {
          var i = (y * W + x) * 4;
          if (d[i + 3] < 128) continue;
          if (alphaAt(x - 1, y) >= 128 && alphaAt(x + 1, y) >= 128 &&
              alphaAt(x, y - 1) >= 128 && alphaAt(x, y + 1) >= 128) continue;
          sumR += d[i]; sumG += d[i + 1]; sumB += d[i + 2]; count++;
        }
      }
      if (count > 0) {
        return new THREE.Color(sumR / count / 255, sumG / count / 255, sumB / count / 255);
      }
    } catch (error) {
      console.warn('[DVB-AR] edge colour sampling skipped:', error && error.message);
    }
    return new THREE.Color(fallbackHex);
  }
  function buildMeshMulti(THREE, geom, tex, preset, texNormal, texRough, texAO, edgeColor) {
    var normalTex = texNormal || createCarpetNormalTexture(THREE);
    var ns = texNormal ? 2.5 : (preset.normalScale || 0.75);
    var sheenCol = new THREE.Color(0.35, 0.33, 0.32);
    var topOpts = {
      map: tex,
      roughness: preset.topRoughness,
      metalness: preset.topMetalness,
      normalMap: normalTex,
      normalScale: new THREE.Vector2(ns, ns),
      sheen: 0.65,
      sheenRoughness: 0.65,
      sheenColor: sheenCol,
      side: THREE.DoubleSide,
      transparent: false,
      alphaTest: 0.05,
      depthWrite: true,
    };
    if (texRough) {
      topOpts.roughnessMap = texRough;
      topOpts.roughness = 1.0;
    }
    if (texAO) {
      topOpts.aoMap = texAO;
      topOpts.aoMapIntensity = 1.4;
    }
    var matTop = new THREE.MeshPhysicalMaterial(topOpts);
    var matSide = new THREE.MeshStandardMaterial({
      color: edgeColor || new THREE.Color(preset.sideColor),
      roughness: preset.sideRoughness,
      metalness: 0,
      side: THREE.DoubleSide,
    });
    var mesh = new THREE.Mesh(geom, [matTop, matSide]);
    mesh.castShadow = false;
    mesh.receiveShadow = false;
    console.log('[AR-MAT] GLB HD PBR', { normalMap: !!normalTex, roughnessMap: !!texRough, aoMap: !!texAO, sideVisible: true });
    return mesh;
  }
  function buildMeshSingle(THREE, geom, tex, preset, texNormal, texRough, texAO) {
    // ar52: texture-derived normal+roughness map kullan. Eski generic noise normal
    // map yerine halının kendi desenine uygun gerçek 3D illüzyonu.
    var normalTex = texNormal || createCarpetNormalTexture(THREE);
    // ar54: normalScale 1.5 → 2.5. iOS Quick Look render'ında normal map etkisi
    // konservatif değerlerde fark edilemiyor, agresif scale gerekli.
    var ns = texNormal ? 2.5 : (preset.normalScale || 0.75);
    var sheenCol = new THREE.Color(0.35, 0.33, 0.32);
    var matOpts = {
      map: tex,
      roughness: preset.topRoughness,
      metalness: preset.topMetalness,
      normalMap: normalTex,
      normalScale: new THREE.Vector2(ns, ns),
      sheen: 0.65,
      sheenRoughness: 0.65, // ar49: 0.82→0.65. Hav parlaklığı daha okunabilir, halı havı hissi öne geçer.
      sheenColor: sheenCol,
      side: THREE.FrontSide,
      // ar45-noshadow: CUTOFF mode + NO shadow.
      transparent: false,
      // ar45-aa: alphaTest 0.15 → 0.05. Silhouette 100 sabit (mesh stabil).
      // Saçak T-tutam AA ucu (alpha 13-99) artık görünür → doğal yumuşak uç.
      // Halo riski yok: preprocessForUsdz RGB siyah → halı_avg, AA piksel halı renginde.
      alphaTest: 0.05,
      depthWrite: false,
    };
    // ar52: roughness map varsa multiplier rolünde 1.0 baz, gerçek varyasyon map'tan.
    if (texRough) {
      matOpts.roughnessMap = texRough;
      matOpts.roughness = 1.0;
    }
    // ar53/ar54: AO map — desen kabarık 3D illüzyonu. aoMapIntensity 1.0 → 1.4 agresif.
    if (texAO) {
      matOpts.aoMap = texAO;
      matOpts.aoMapIntensity = 1.4;
    }
    var mat = new THREE.MeshPhysicalMaterial(matOpts);
    console.log('[AR-MAT] buildMeshSingle (ar53): CUTOFF + texNormal=' + !!texNormal + ' + texRough=' + !!texRough + ' + texAO=' + !!texAO);
    var mesh = new THREE.Mesh(geom, mat);
    // ar45-noshadow: USDZ path mesh shadow=FALSE → ARKit drop shadow YOK → halo YOK
    mesh.castShadow = false; mesh.receiveShadow = false;
    return mesh;
  }

  function buildScene(THREE, mesh, opts) {
    var scene = new THREE.Scene();
    // ar45-noshadow: NO LIGHTS → USDZ scene'de shadow yok → halı altında siyah halo yok.
    // iOS Quick Look default IBL kullanır.
    scene.add(mesh);
    // ar53: ÇİFT katmanlı soft + contact shadow — halı yere serilme hissi.
    // Inner contact (sıkı koyu) + outer soft (geniş yumuşak). USDZ geom +0.5mm
    // lift edildiği için bu gölgeler zeminde (Y=0) halı altında doğal görünür.
    if (opts && opts.shadow && opts.halfW > 0 && opts.halfH > 0) {
      var shadowGroup = createDualGroundShadow(THREE, opts.halfW, opts.halfH);
      scene.add(shadowGroup);
    }
    return scene;
  }

  // ═══════════════════ EXPORT GLB / USDZ ═══════════════════
  async function exportGLB(THREE, GLTFExporter, scene) {
    var exporter = new GLTFExporter();
    return new Promise(function (resolve, reject) {
      exporter.parse(
        scene,
        function (result) {
          if (result instanceof ArrayBuffer) resolve(new Blob([result], { type: 'model/gltf-binary' }));
          else reject(new Error('GLB sonucu binary değil'));
        },
        function (err) { reject(err); },
        { binary: true, embedImages: true, includeCustomExtensions: false }
      );
    });
  }

  async function exportUSDZ(USDZExporter, scene) {
    var exporter = new USDZExporter();
    // Three.js r160: USDZExporter.parse() async; eski sürümlerde parseAsync.
    // Defansif: hangisi varsa onu kullan.
    var fn = (typeof exporter.parseAsync === 'function')
      ? exporter.parseAsync.bind(exporter)
      : exporter.parse.bind(exporter);
    var arrayBuffer = await fn(scene, { maxTextureSize: TEXTURE_TARGET_PX });
    return new Blob([arrayBuffer], { type: 'model/vnd.usdz+zip' });
  }

  // ═══════════════════ CACHE / UPLOAD ═══════════════════
  async function arCheck(hash) {
    /* R2 server-side cache aktif — hash match → hazır GLB+USDZ döner, anında açılır */
    var r = await fetch(API_BASE + '/api/ar/check', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ hash: hash }),
    });
    if (!r.ok) throw new Error('Cache kontrolü başarısız (HTTP ' + r.status + ')');
    return await r.json();
  }

  // ar35: Cache hit gelse bile R2'deki dosyaların gerçek boyutunu doğrula.
  // Worker'ın `alreadyCached:true` mantığı bozuk — meta DB'de "var" diyor ama
  // R2'deki dosya 0 veya 7 byte olabilir → "düz gri" hatası.
  async function getRemoteSize(url) {
    try {
      var r = await fetch(url, { method: 'HEAD' });
      if (!r.ok) return 0;
      return parseInt(r.headers.get('content-length') || '0', 10);
    } catch (_) { return 0; }
  }
  async function arCheckVerified(hash) {
    var existing = await arCheck(hash);
    if (!existing.glb || !existing.usdz) return existing;
    var glbU = fullUrl(existing.glb), usdzU = fullUrl(existing.usdz);
    var sizes = await Promise.all([getRemoteSize(glbU), getRemoteSize(usdzU)]);
    var glbSize = sizes[0], usdzSize = sizes[1];
    if (glbSize >= 50000 && usdzSize >= 30000) {
      existing._glbSize = glbSize; existing._usdzSize = usdzSize;
      return existing;
    }
    console.warn('[AR] cache poisoned hash', hash, '→ glb:' + glbSize + ' usdz:' + usdzSize, '— bypass');
    return { glb: null, usdz: null, _poisoned: true, _sizes: { glb: glbSize, usdz: usdzSize } };
  }

  async function arUploadOne(hash, type, blob) {
    var r = await fetch(API_BASE + '/api/ar/upload/' + hash + '.' + type, {
      method: 'PUT',
      body: blob,
    });
    if (!r.ok) throw new Error('Yükleme başarısız (' + type + ', HTTP ' + r.status + ')');
    var meta = await r.json();
    if (!meta.ok) throw new Error(meta.error || 'Yükleme başarısız (' + type + ')');
    return meta.assetURL;
  }

  function fullUrl(path) {
    if (!path) return '';
    // ar34: r2.dev Türkiye'de bloke. r2.dev URL'lerini Worker proxy'ye çevir:
    // https://pub-XXX.r2.dev/ar-cache/HASH.glb → API_BASE/api/ar/file/HASH.glb
    // Workers.dev domain'i engelsiz → telefon modeli alabilir.
    var r2Match = path.match(/r2\.dev\/ar-cache\/(.+)$/);
    if (r2Match) return API_BASE + '/api/ar/file/' + r2Match[1];
    if (path.indexOf('http') === 0) return path;
    return API_BASE + path;
  }

  // ═══════════════════ ANA AKIŞ ═══════════════════
  function isMobile() {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  }

  async function generateAndShow(overrideState, overrideSourceCanvas) {
    // ar40: Cart AR override — sepet butonu state+canvas dışarıdan verebilir.
    var state = overrideState || readDesignState();
    var _sourceCanvasOverride = overrideSourceCanvas || null;

    // ── ar29: QR/URL hash bypass ──────────────────────────────────────────────
    // Masaüstünde QR üretilirken URL'ye h=HASH parametresi gömülür.
    // Telefon QR'ı okutunca bu URL açılır → h parametresi varsa cache'den direkt
    // model alınır; kullanıcı hiçbir şey girmek zorunda kalmaz.
    (function applyUrlState() {
      var up = new URLSearchParams(location.search);
      var h = up.get('h');
      if (!h) return;
      // ar34: version guard — QR URL'deki v mevcut CACHE_VERSION ile uyuşmazsa
      // hash'i ignore et (eski/bozuk model yerine yeni model üretilsin).
      // State parametreleri (ölçü, şekil, kalite) yine URL'den alınır → seamless.
      var urlV = up.get('v') || '';
      var hashFromUrl = (urlV === CACHE_VERSION) ? h : null;
      if (hashFromUrl) {
        // Hash geçerli — state'e yaz, arCheck cache'den alacak.
        state._urlHash = hashFromUrl;
      } else {
        console.log('[DVB-AR] QR version mismatch:', urlV, '!=', CACHE_VERSION, '— yeni model üretilecek');
      }
      var wMm = parseInt(up.get('w') || '0', 10);
      var lMm = parseInt(up.get('l') || '0', 10);
      if (wMm > 0) state.widthCm  = wMm / 10;
      if (lMm > 0) state.lengthCm = lMm / 10;
      if (up.get('sh')) state.shape       = up.get('sh');
      if (up.get('q'))  state.qualityCode = up.get('q');
      if (up.get('e'))  state.edge        = up.get('e');
    })();

    if (!(state.widthCm > 0 && state.lengthCm > 0)) {
      // ar34: version-checked hash varsa (state._urlHash) devam, yoksa hata
      if (!state._urlHash) {
        setError('Önce halı ölçülerini (en/boy) girin.');
        return;
      }
    }

    // URL'de hash varsa → cache'den direkt model al, 3D üretimi atla.
    // ar34: state._urlHash kullan (applyUrlState version-checked; eski/bozuk QR'larda null).
    var _qrHash = state._urlHash || null;
    if (_qrHash) {
      setLoading('Halı modeli yükleniyor…');
      var _cached;
      try { _cached = await arCheckVerified(_qrHash); } catch (_e) { _cached = {}; }
      if (_cached.glb && _cached.usdz) {
        lastResult = {
          hash: _qrHash,
          glb: fullUrl(_cached.glb), usdz: fullUrl(_cached.usdz),
          glbSize: _cached._glbSize || 0, usdzSize: _cached._usdzSize || 0,
          fromCache: true, v: DVB_AR_VERSION
        };
        await renderViewer(state, lastResult);
        return;
      }
      // Cache miss VEYA poisoned → normal üretim akışına devam
    }
    // ─────────────────────────────────────────────────────────────────────────

    var sourceCanvas = _sourceCanvasOverride || (await pickSourceCanvas(state));
    if (!sourceCanvas) {
      setError('Halı önizlemesi henüz hazır değil. Lütfen birkaç saniye bekleyip tekrar deneyin.');
      return;
    }

    // ar35: Source canvas pixel imzası — biye/bordür rengi/deseni veya kumaş seçimi
    // değişince state objesi aynı kalsa bile canvas piksel datası değişir. Bu imzayı
    // hash'e koymadan yapılırsa: kullanıcı bordür değiştirir → state.edge='bordur' aynı
    // → cache hit → eski model döner → yeni bordür AR'da görünmez.
    // Hızlı imza: 32×32 downsampled canvas'ın RGB bytes'ı (~3KB string).
    function canvasSignature(cv) {
      try {
        var sig = document.createElement('canvas');
        sig.width = 32; sig.height = 32;
        var sctx = sig.getContext('2d');
        sctx.drawImage(cv, 0, 0, 32, 32);
        var d = sctx.getImageData(0, 0, 32, 32).data;
        // RGB only (alpha çıkar — sıkıştırılır)
        var arr = new Array(32 * 32 * 3);
        for (var i = 0, j = 0; i < d.length; i += 4) {
          arr[j++] = d[i]; arr[j++] = d[i+1]; arr[j++] = d[i+2];
        }
        return arr.join(',');
      } catch (_) { return 'nosig'; }
    }
    var canvasSig = canvasSignature(sourceCanvas);

    // ar47d: GEÇİCİ cache bust — kullanıcı tarafında iOS USDZ + Safari + R2 cache üst üste binmiş.
    // Her açılışta fresh hash → fresh USDZ → cache problemi bypass. Test bittikten sonra kaldırılacak.
    var __ar47d_bust = Math.floor(Date.now() / 60000); // 60sn cache pencere (aynı dakika içi tekrar test = hit)
    // Hash girdisi: deterministik (mm hassasiyeti — 200.5 ve 200.4 collide olmasın)
    var hashInput = JSON.stringify({
      _bust: __ar47d_bust, // ar47d: cache bypass için zaman damgası
      v: CACHE_VERSION,
      q: state.qualityCode,
      pk: state.patternKey,
      sh: state.shape,
      w: Math.round(state.widthCm * 10),
      l: Math.round(state.lengthCm * 10),
      e: state.edge,
      a: state.amorfRadii,
      c: state.amorfContour,
      cs: canvasSig, // ar35: pixel imza → biye/bordür/kumaş değişince fresh model
    });
    var hash = (await sha256Hex(hashInput)).slice(0, 32);

    setLoading('Önbellek kontrol ediliyor…');
    var existing;
    try { existing = await arCheckVerified(hash); }
    catch (e) { setError(e.message || String(e)); return; }

    // ar35: cache poisoned (Worker'da meta var ama R2'de dosya bozuk) → upload hash'ini bust et.
    // Aynı hash ile upload Worker tarafından "alreadyCached" diye reddediliyor ve eski bozuk
    // dosya kullanılmaya devam ediyor. Hash'e tek seferlik salt ekleyerek Worker'a yeni hash
    // gibi gösterip fresh upload yaptırırız.
    var uploadHash = hash;
    if (existing._poisoned) {
      var saltInput = hash + ':bust:' + Date.now() + ':' + Math.random();
      uploadHash = (await sha256Hex(saltInput)).slice(0, 32);
      console.log('[AR] cache poisoned bypass: orig=' + hash + ' → upload=' + uploadHash);
    }

    var glbURL = existing.glb;
    var usdzURL = existing.usdz;
    var glbSize = 0, usdzSize = 0;
    var fromCache = !!(glbURL && usdzURL);

    if (!glbURL || !usdzURL) {
      setLoading('Halınız 3D olarak tasarlanıyor…<br><span style="font-size:12px;color:#666">İlk üretim 10-20 saniye sürebilir, lütfen bekleyin.</span>');
      var mods;
      try { mods = await loadThree(); }
      catch (e) { setError('3D motoru yüklenemedi: ' + (e.message || e)); return; }

      try {
        // ar51: AMORF + DAIRE/OVAL/CIRCLE → AmorfFix v2 pipeline (silhouette-trace mesh).
        // Eski pipeline (buildGeomAndTex) yuvarlak halı için math primary daire mesh
        // üretiyordu; mesh halı silhouette'inden büyük olunca texture'ın transparent
        // dış alanları mesh üzerine UV ile haritalanıyor → premultiply nedeniyle SİYAH
        // OPAQUE oval (kullanıcının iPhone'da gördüğü hata). solveAmorfMesh mesh'i
        // texture silhouette'ini birebir takip eder + cropped canvas üretir → mesh dışı
        // UV YOK → siyah taban yok, saydamlık korunur.
        // Sadece dikdörtgen (rectangle) eski pipeline'da kalır — mesh = texture frame.
        var bundle;
        var useAmorfPipeline = (state.shape === 'amorf' || state.shape === 'oval' ||
                                 state.shape === 'daire' || state.shape === 'circle');
        if (useAmorfPipeline) {
          bundle = await buildAmorfBundle(mods.THREE, state, sourceCanvas);
        } else {
          var hi = upscaleCanvas(sourceCanvas, TEXTURE_TARGET_PX);
          bundle = await buildGeomAndTex(mods.THREE, state, hi);
        }

        if (!glbURL) {
          setLoading('AR modeli oluşturuluyor… <br><span style="font-size:12px;color:#666">Lütfen bekleyin, telefona aktarılıyor.</span>');
          // GLB için multi-material mesh (üst doku + yan kenar farklı renk)
          var meshGlb = buildMeshMulti(
            mods.THREE, bundle.geomGlb, bundle.texGlb, bundle.preset,
            bundle.texNormal, bundle.texRough, bundle.texAO, bundle.edgeColor
          );
          // GLB tarafında shadow plane EKLEMEYIZ — Android Scene Viewer UNLIT modda
          // material'ı zaten katmanlıyor, ekstra plane halı altında "iki kat" görünür.
          var sceneGlb = buildScene(mods.THREE, meshGlb);
          var glbBlob = await exportGLB(mods.THREE, mods.GLTFExporter, sceneGlb);
          glbSize = glbBlob.size;
          console.log('[AR] GLB blob', { hash: hash, bytes: glbBlob.size });
          // ar35: sanity check — texture'sız GLB ~8KB civarı olur (sadece geometry).
          // Texture'lı GLB en az ~50KB. Bu altındaysa texture eksik → "düz gri" hatası.
          if (glbBlob.size < 50000) {
            throw new Error('GLB üretimi eksik (texture yok, ' + glbBlob.size + ' byte). Sayfayı yenileyip tekrar deneyin.');
          }
          setLoading('Model buluta yükleniyor… <br><span style="font-size:12px;color:#666">Neredeyse bitti, birkaç saniye.</span>');
          glbURL = await arUploadOne(uploadHash, 'glb', glbBlob);
        }
        if (!usdzURL) {
          setLoading('iPhone AR modeli hazırlanıyor… <br><span style="font-size:12px;color:#666">Telefonunuzda açılmaya hazır olacak.</span>');
          // USDZ için TEK material mesh (USDZExporter array material desteklemiyor;
          // multi-material verirsek mesh USDZ scene'ine eklenmez ve Quick Look boş olur).
          // ar53: USDZ tarafı — texture-based normal+roughness+AO map ve çift katmanlı ground shadow.
          var meshUsdz = buildMeshSingle(
            mods.THREE, bundle.geomUsdz, bundle.texUsdz, bundle.preset,
            bundle.texNormal, bundle.texRough, bundle.texAO
          );
          // Native Quick Look supplies floor contact; synthetic black planes caused a floating seam.
          var sceneUsdz = buildScene(mods.THREE, meshUsdz);
          var usdzBlob = await exportUSDZ(mods.USDZExporter, sceneUsdz);
          usdzSize = usdzBlob.size;
          console.log('[AR] USDZ blob', { hash: hash, bytes: usdzBlob.size });
          // ar35: USDZ sanity check — texture'sız USDZ <30KB olur.
          if (usdzBlob.size < 30000) {
            throw new Error('USDZ üretimi eksik (texture yok, ' + usdzBlob.size + ' byte). Sayfayı yenileyip tekrar deneyin.');
          }
          setLoading('Model buluta yükleniyor… <br><span style="font-size:12px;color:#666">Neredeyse bitti, birkaç saniye.</span>');
          usdzURL = await arUploadOne(uploadHash, 'usdz', usdzBlob);
        }
      } catch (e) {
        console.error('[AR] üretim hatası', e);
        setError('3D model üretilirken bir hata oluştu: ' + (e.message || e));
        return;
      }
    }

    lastResult = {
      hash: uploadHash,
      origHash: hash,
      poisonedBypass: !!existing._poisoned,
      glb: fullUrl(glbURL),
      usdz: fullUrl(usdzURL),
      glbSize: glbSize, usdzSize: usdzSize, fromCache: fromCache,
      v: DVB_AR_VERSION
    };
    // DEBUG: window'a expose et — kullanıcı sorun bildirdiğinde URL paylaşılabilsin
    try { window.__AR_LAST_RESULT__ = lastResult; } catch (_) {}
    console.log('[AR] result available at window.__AR_LAST_RESULT__:', lastResult);
    await renderViewer(state, lastResult);
  }

  async function renderViewer(state, result) {
    setLoading('AR açılıyor… <br><span style="font-size:12px;color:#666">Kamera izni istenebilir.</span>');
    await loadModelViewer();

    var dimsLabel = state.widthCm + ' × ' + state.lengthCm + ' cm — ' + state.shape.toUpperCase();
    var alt = 'Paradiso Plus halı 3D model — ' + dimsLabel;

    // Mobil → 3D inline preview (top-down, galeri ile uyumlu) + manuel AR butonu
    // ar17: setTimeout(doLaunch, 350) KALDIRILDI — user gesture context dışındaki
    // mv.activateAR() iOS Safari + Android Chrome tarafından REDDEDILIYOR
    // ("No AR Mode can be activated"). User manuel butona basarak gesture
    // context'inde AR başlatılır. Bu güvenlik gereklidir.
    //
    // Inline preview camera-orbit "0deg 0deg auto" — top-down (yer planı görünümü).
    // Galeri 2D top-down ile aynı perspektif → user "amorf yapıyı anlamıyor" yorumu
    // önlenir. Halı yer planında nasıl duracağı net görülür.
    if (isMobile()) {
      setBody(
        '<div style="font-size:13px;color:#555;margin-bottom:8px;">' + dimsLabel + '</div>' +
        '<model-viewer class="dvb-ar-mv" id="dvb-ar-mv-el" alt="' + alt + '"' +
          ' src="' + result.glb + '"' +
          ' ios-src="' + result.usdz + '"' +
          ' ar ar-modes="webxr scene-viewer quick-look"' +
          ' camera-controls touch-action="pan-y"' +
          ' camera-orbit="30deg 75deg auto"' +
          ' field-of-view="35deg"' +
          ' shadow-intensity="0" exposure="1.0"' +
          ' ar-scale="fixed"' +
          ' interaction-prompt="none"' +
          ' style="background:transparent">' +
        '</model-viewer>' +
        '<button type="button" class="dvb-ar-mobile-cta" id="dvb-ar-launch" style="font-size:16px;font-weight:700;padding:16px;">📱 Halıyı Odanızda Görün — AR\'da Aç</button>' +
        '<div style="font-size:11px;color:#888;text-align:center;margin-top:8px;">Yukarıda 3D önizleme · Butona basınca telefon kameranızla 1:1 ölçekte yer planına yerleştirin</div>'
      );
      var mv = document.getElementById('dvb-ar-mv-el');
      var launch = document.getElementById('dvb-ar-launch');
      // ar19: model-viewer.activateAR() iOS/Android'de "No AR Mode can be activated"
      // hatası veriyordu (gesture context veya capability detection sorunu).
      // Çözüm: native AR intent — direkt USDZ link iOS için, scene-viewer Android için.
      // Bu Apple Quick Look ve Google Scene Viewer'ın resmi pattern'i.
      var ua = navigator.userAgent;
      var isIOS = /iPhone|iPad|iPod/i.test(ua);
      var isAndroid = /Android/i.test(ua);
      function doLaunch(e) {
        if (e) e.preventDefault();
        // ar55: AR'a geçmeden önce modal videosunu durdur (Quick Look/Scene Viewer
        // arka planda iken telefon ses/CPU tüketmesin).
        try { if (typeof stopRugVideo === 'function') stopRugVideo(); else if (window.__dvbStopRugVideo__) window.__dvbStopRugVideo__(); } catch(_e){}
        try {
          if (isIOS) {
            // iOS Safari → Apple Quick Look. <a rel="ar"> + img child gerekli.
            var a = document.createElement('a');
            a.rel = 'ar';
            a.href = result.usdz;
            // Quick Look spec: <a> içinde <img> olmalı yoksa download tetikler
            var img = document.createElement('img');
            img.style.cssText = 'width:1px;height:1px;display:none';
            a.appendChild(img);
            document.body.appendChild(a);
            a.click();
            setTimeout(function () { a.remove(); }, 100);
            console.log('[AR] iOS Quick Look launched:', result.usdz);
          } else if (isAndroid) {
            // DV_AR_REAL_WORLD_OCCLUSION_20260807
            // ARCore Depth occlusion is explicitly enabled. Real people/objects
            // that are closer to the camera can cover the rug on supported devices.
            // The current page is the safe fallback when ARCore is unavailable.
            var arFallback = window.location.href;
            var intentUrl = 'intent://arvr.google.com/scene-viewer/1.2?file=' + encodeURIComponent(result.glb) +
              '&mode=ar_only&resizable=false&disable_occlusion=false#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;S.browser_fallback_url=' + encodeURIComponent(arFallback) + ';end;';
            window.location.href = intentUrl;
            console.log('[AR] Android ARCore depth occlusion intent:', result.glb);
          } else {
            // Fallback: model-viewer'ın kendi activateAR'ı (genelde başarısız ama dener)
            mv.activateAR();
            console.log('[AR] model-viewer activateAR fallback');
          }
        } catch (err) {
          console.warn('[AR] launch err', err);
        }
      }
      launch.addEventListener('click', doLaunch);
    } else {
      // Desktop: 3D viewer + QR
      // ar29: URL'ye hash + state parametreleri gömülür → telefon QR'ı okutunca
      // aynı halıyı (şekil, ölçü, kalite) direkt cache'den açar, sıfırdan girmez.
      var qrParamsObj = {
        dvbAr: '1',
        v: CACHE_VERSION,   // ar34: version guard — eski QR'lar yeni JS ile uyuşmazsa hash ignore
        h: result.hash,
        sh: state.shape || '',
        w: Math.round((state.widthCm || 0) * 10),
        l: Math.round((state.lengthCm || 0) * 10),
        q: state.qualityCode || '',
        e: state.edge || '',
      };
      var qrTargetURL = location.origin + location.pathname + '?' + new URLSearchParams(qrParamsObj).toString();
      var qrPng = '';
      try {
        var qr = await loadQR();
        qrPng = await qr.toDataURL(qrTargetURL, { width: 260, margin: 1, color: { dark: '#1a1a1a', light: '#ffffff' } });
      } catch (e) {}
      // ar31: Yan yana layout — model-viewer sol, QR sağ.
      // Scroll olmadan her ikisi de görünür. Model-viewer 260px yüksek.
      setBody(
        '<div style="font-size:13px;color:#555;margin-bottom:10px;">' + dimsLabel + '</div>' +
        '<div style="display:flex;gap:16px;align-items:flex-start;">' +
          '<div style="flex:1;min-width:0;">' +
            '<model-viewer class="dvb-ar-mv" alt="' + alt + '"' +
              ' src="' + result.glb + '"' +
              ' ios-src="' + result.usdz + '"' +
              ' camera-controls auto-rotate auto-rotate-delay="800"' +
              ' camera-orbit="30deg 70deg auto"' +
              ' shadow-intensity="0.8" exposure="1.1"' +
              ' style="background:transparent;width:100%;height:260px;border-radius:8px;">' +
            '</model-viewer>' +
          '</div>' +
          '<div style="flex:0 0 auto;display:flex;flex-direction:column;align-items:center;gap:10px;">' +
            (qrPng ? '<img src="' + qrPng + '" alt="QR kod" style="width:140px;height:140px;background:#fff;padding:6px;border-radius:8px;border:1px solid #eee;">' : '<div style="width:140px;height:140px;display:flex;align-items:center;justify-content:center;font-size:11px;color:#aaa;border:1px solid #eee;border-radius:8px;">QR yüklenemedi</div>') +
            '<div style="font-size:12px;color:#444;text-align:center;line-height:1.4;max-width:140px;">' +
              '<strong style="display:block;font-size:13px;color:#1a1a1a;margin-bottom:3px;">Telefonda aç</strong>' +
              'QR\'ı tarayın, AR anında açılır.' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }
  }

  // ═══════════════════ CLICK HANDLER ═══════════════════
  async function onArClick() {
    console.log('[AR] onArClick çağrıldı'); // ar55.15 debug
    // ar55.15: disabled guard KALDIRILDI. updateButtonState artık btn.disabled=false
    // tutuyor; eski guard burada click'i hiç işlenmeden yutuyordu.
    openModal();
    setLoading('Halınız hazırlanıyor…');
    await yieldToUI(50); // ar55.14: modal render edilsin, sonra ağır işlem başlasın
    try { await generateAndShow(); }
    catch (e) {
      console.error('[AR] beklenmeyen hata', e);
      setError(e.message || String(e));
    }
  }

  // ═══════════════════ INIT ═══════════════════
  function init() {
    if (inited) return;
    var qc = detectQualityCode();
    if (!isWhitelisted(qc)) {
      // Whitelist dışı: hiçbir şey yapma
      // console.debug('[AR] whitelist dışı:', qc);
      return;
    }
    inited = true;
    injectStyles();
    ensureModal();         // ar55.4: modal DOM'u önceden oluştur — ilk tıkta gecikme olmasın.
    injectButton();
    bindEagerModalOpen();  // ar55.4: tema butonuna capture-phase listener → anında açılış.
    /* DV_AR_CLICK_ONLY_20260729: Three/model-viewer explicit AR tiklamasinda yuklenir. */         // ar55.6: arka planda Three.js + model-viewer yükle.

    // Ölçü değişince butonun durumunu güncelle
    ['ozel-olcu-width', 'ozel-olcu-length', 'ozel-olcu-shape'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) {
        el.addEventListener('input', updateButtonState);
        el.addEventListener('change', updateButtonState);
      }
    });
    // Mevcut config değişince button reflect et
    setInterval(updateButtonState, 1500);

    // QR ile gelinen mobil link → AR'ı otomatik aç (sayfa hazır olduğunda)
    // ar55.12: 2200ms → 500ms; QR açılır açılmaz modal + hızlı görsel yolu.
    if (/dvbAr=/.test(location.hash) || /[?&]dvbAr=1/.test(location.search)) {
      setTimeout(function () {
        // Hemen modal + yükleniyor göster — boş ekranda bekleme olmasın.
        injectStyles();
        ensureModal();
        openModal();
        setLoading('Halınız hazırlanıyor…');

        // ar55.12: Hızlı yol — orijinal Shopify görselini AI beklemeksizin kullan.
        // V5'in removeWhiteBg (Transformers.js + RMBG, ~30-60sn) _arPipelineLock ile
        // bloke edilir. Orijinal görsel eşik-tabanlı BG kaldırma ile kullanılır (~<1sn).
        var qs       = new URLSearchParams(location.search);
        var shape    = qs.get('sh') || 'dikdortgen';
        var wMm      = parseInt(qs.get('w') || '0', 10);
        var lMm      = parseInt(qs.get('l') || '0', 10);
        var widthCm  = wMm  ? wMm  / 10 : 150;
        var lengthCm = lMm  ? lMm  / 10 : 200;
        var quality  = qs.get('q')  || 'paradiso-plus';
        var edge     = qs.get('e')  || 'biye';

        // Handle: /products/HANDLE → yalnızca ürün sayfasında çalışır.
        var pathParts = window.location.pathname.split('/products/');
        var handle    = pathParts.length > 1 ? pathParts[1].split('/')[0] : '';

        if (handle) {
          var xhrQ = new XMLHttpRequest();
          xhrQ.open('GET', '/products/' + handle + '.js', true);
          xhrQ.onload = function () {
            if (_arPipelineLock) return; // V5 zaten başlattıysa dur
            try {
              var prod   = JSON.parse(xhrQ.responseText);
              var imgUrl = prod.featured_image || (prod.images && prod.images[0]) || '';
              if (imgUrl) imgUrl = imgUrl.replace(/^\/\//, 'https://').replace(/\?.*$/, '');
              if (imgUrl && typeof window.dvbArShowForCartItem === 'function') {
                console.log('[DVB-AR] QR hızlı yol: orijinal görsel ile AR başlatılıyor');
                window.dvbArShowForCartItem({
                  previewUrl:   imgUrl,
                  widthCm:      widthCm,
                  lengthCm:     lengthCm,
                  shape:        shape,
                  edgeType:     edge,
                  qualityCode:  quality,
                  radiiJson:    '',
                  productHandle: handle,
                  _quickPath:   true  // eşik-tabanlı beyaz BG kaldırma kullan
                });
              }
            } catch (e) { console.warn('[DVB-AR] QR hızlı yol XHR hata:', e); }
          };
          xhrQ.send();
        }

        // Özel ölçü sayfasında kendi butonumuz varsa onu da tıkla (override durumu).
        updateButtonState();
        var b = document.getElementById('dvb-ar-btn');
        if (b && !b.disabled) b.click();
      }, 500);
    }
  }

  // ar55.6: Arka planda kütüphane ön yükleme — kullanıcı tıkladığında Three.js + model-viewer
  // zaten yüklenmiş olacak, ilk tıkta "kasma" hissi ortadan kalkar.
  // requestIdleCallback ile sayfa tamamen hazır olunca başlar, sayfayı yavaşlatmaz.
  var _preWarmDone = false;
  function preWarmLibs() {
    if (_preWarmDone) return;
    _preWarmDone = true;
    function doWarm() {
      // Three.js + GLTFExporter + USDZExporter önceden yükle (en ağır parça ~500KB+)
      loadThree().catch(function (e) {
        console.warn('[AR] preWarm Three failed (sessiz, tıkta tekrar denenir):', e && e.message);
        _preWarmDone = false; // Başarısız olduysa tıkta tekrar denensin.
      });
      // model-viewer önceden yükle
      loadModelViewer().catch(function () {});
    }
    // Tarayıcı boşta iken başla (sayfanın yüklenmesini engelleme).
    if (typeof requestIdleCallback !== 'undefined') {
      requestIdleCallback(doWarm, { timeout: 6000 });
    } else {
      // requestIdleCallback yoksa (Safari <16) 3.5sn sonra başla.
      setTimeout(doWarm, 3500);
    }
  }

  // ar55.4: Tema butonu (dvb-ar-product-btn) tıklanınca dvbArShowForCartItem çağrılmadan
  // ÖNCE modal'ı ve "yükleniyor" mesajını anında göster. Theme.liquid'deki loadAr callback
  // gecikmesi (script yükleme veya network) kullanıcıyı boş ekranda bekleme.
  // Capture phase (true) sayesinde tema handler'ından önce çalışır.
  var EAGER_BTN_ID = 'dvb-ar-product-btn';
  function bindEagerModalOpen() {
    // ar55.8: Eski yaklaşım — element'e addEventListener. SORUN: theme.liquid V5'in
    // attachToBtn() fonksiyonu btn.cloneNode(true) + replaceChild yapar →
    // klonlama element üzerindeki listener'ları siler → tıklanınca modal açılmıyor.
    //
    // Çözüm: document'e capture-phase delegation. DOM mutation'lardan bağımsız;
    // buton klonlansa/değişse de document listener çalışır. Tıklama anında modal
    // açılır ("Halınız hazırlanıyor"), V5'in XHR+AI akışı arka planda devam eder.
    if (window._dvbDocEagerBound) return;
    window._dvbDocEagerBound = true;
    document.addEventListener('click', function (e) {
      // Tıklama butonun içindeki bir span/text'e denk gelebilir — üste çık.
      var el = e.target;
      while (el && el.nodeType === 1) {
        if (el.id === EAGER_BTN_ID) {
          injectStyles();
          ensureModal();
          openModal();
          setLoading('Halınız hazırlanıyor…');
          return; // yeterli — V5 handler'ı bubble/capture sonrasında kendi işini görür.
        }
        el = el.parentElement;
      }
    }, true /* capture — V5'in bubble-phase handler'ından önce */);
  }

  function bootstrap() {
    // banner-product.js init'inden sonra çalış (kalite tespiti için config gerekli)
    // ar30: tries > 12 (3 saniye) → her halükarda init — __OZEL_OLCU_CONFIG__ gelmese de
    // detectQualityCode artık 'paradiso-plus' fallback döndürdüğü için buton eklenir.
    var tries = 0;
    (function poll() {
      tries++;
      if (window.__OZEL_OLCU_CONFIG__ || tries > 12) {
        init();
        return;
      }
      setTimeout(poll, 250);
    })();
  }

  // ═══════════════════ CART AR API ═══════════════════
  // Sepet sayfasından / drawer'dan AR açmak için global trigger.
  // cart-customizations.js "Halıyı Evimde Gör" butonuna tıklandığında çağırır.
  // opts: { previewUrl, widthCm, lengthCm, shape, edgeType, qualityCode,
  //         radiiJson (JSON string), productHandle }
  window.dvbArShowForCartItem = async function(opts) {
    // ar55.10: Paralel tıklamayı engelle — pipeline zaten çalışıyorsa yeni çağrı yok sayılır.
    if (_arPipelineLock) {
      console.log('[DVB-AR] pipeline zaten çalışıyor, tekrar tıklama yok sayıldı');
      return;
    }
    _arPipelineLock = true;
    injectStyles();
    ensureModal();
    openModal();
    setLoading('Halınız hazırlanıyor…');
    try {
      var state = {
        widthCm:     parseFloat(opts.widthCm)  || 0,
        lengthCm:    parseFloat(opts.lengthCm) || 0,
        shape:       (opts.shape      || 'dikdortgen').toLowerCase(),
        edge:        (opts.edgeType   || 'biye').toLowerCase(),
        qualityCode: (opts.qualityCode|| 'paradiso-plus').toLowerCase(),
        patternKey:  opts.productHandle || '',
        amorfRadii:  null,
        amorfContour: null,
        productData: opts.productData || { description: document.body.innerText || '' }
      };
      // _radii JSON parse
      if (opts.radiiJson) {
        try { state.amorfRadii = JSON.parse(opts.radiiJson); } catch (e) {}
      }
      // Preview URL → canvas
      if (!opts.previewUrl) { setError('Önizleme görseli bulunamadı.'); return; }
      var img = await new Promise(function(resolve, reject) {
        var im = new Image();
        im.crossOrigin = 'anonymous';
        im.onload  = function() { resolve(im); };
        im.onerror = function() { reject(new Error('Önizleme yüklenemedi: ' + opts.previewUrl)); };
        im.src = opts.previewUrl;
      });
      var srcCanvas = document.createElement('canvas');
      srcCanvas.width  = img.naturalWidth  || img.width;
      srcCanvas.height = img.naturalHeight || img.height;
      var sctx = srcCanvas.getContext('2d');
      sctx.drawImage(img, 0, 0);
      // Edge-connected mask replaces the old global RGB>235 threshold; fringe-safe.
      srcCanvas = prepareArStudioTextureCanvas(srcCanvas);
      await generateAndShow(state, srcCanvas);
    } catch(e) {
      console.error('[AR] cart item hata', e);
      setError(e.message || String(e));
    } finally {
      // ar55.10: Pipeline kilidi her durumda serbest bırakılır (hata veya başarı).
      // closeModal() da sıfırlar; iki taraflı reset stale-lock riskini ortadan kaldırır.
      _arPipelineLock = false;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();

